/**
 * @fileoverview Self Submission
 *
 * Self Submission page related components initialization
 */
 import Modal from '../../components/Modal';
 import SelectorEngine from '../../utils/dom/selector-engine';
 import EventHandler from '../../utils/dom/event-handler';
 import Request from '../../utils/request';
 import Manipulator from '../../utils/dom/manipulator';
 import globalselfSubmissionVenueSearch from '../../components/SelfSubmission/SelfSubmissionVenueSearch';
 import SelfSubmissionPlayerSearch from '../../components/SelfSubmission/SelfSubmissionPlayerSearch';
 import CarouselV2 from '../../components/CarouselV2';
 
 const classnames = (...args) => {
	 return args.join(' ');
 };
 class SelfSubmission {
	 constructor() {
		 this.state = {
			 section: 0,
			 currentEventSection: 0,
			 gameSection: 0,
			 availablePlans: [],
			 getDefaultParams: undefined,
			 firstTimeSubmission: undefined,
			 stepDefault: false,
			 stepManual: false,
			 playerFirstName: '',
			 playerLastName: '',
			 partnerFirstName: '',
			 partnerLastName: '',
			 opponent1FirstName: '',
			 opponent1LastName: '',
			 opponent2FirstName: '',
			 opponent2LastName: '',
			 selectedPlan: '',
			 isAddOn: false,
			 isSubmitted: false,
			 dateValue: '',
			 myContactId: '',
			 myContactName: '',
			 myGender: '',
			 recentVenueName: '',
			 favPlayers: '',
			 favVenues: '',
			 recentPlayerListTemplate: undefined,
			 recentVenuesListTemplate: undefined,
			 recentPartnerPlayerListTemplate: '',
			 recentOpponent1PlayerListTemplate: '',
			 recentOpponent2PlayerListTemplate: '',
			 singlesReferralCode: '',
			 partnerRefferalCode: '',
			 opponent1ReferralCode: '',
			 opponent2ReferralCode: '',
			 recentPlayerName: '',
			 selectedVenue: '',
			 selectedPlayer: [{}],
			 selectedPartner: [{}],
			 selectedOpponent1: [{}],
			 selectedOpponent2: [{}],
			 stepPartner: false,
			 stepOpponent1: false,
			 stepOpponent2: false,
			 stepBackPartnerHidden: false,
			 stepBackOpponentHidden: false,
			 partnerNextButton: false,
			 partnerOpponent1Button: false,
			 partnerOpponent2Button: false,
			 defaultVenue: false,
			 defaultSport: false,
			 defaultTennisBallColor: false,
			 defaultMatchCategory: false,
			 sportPlayed: '',
			 matchFormat: '',
			 tennisBallColor: '',
			 matchCategory: '',
			 selectedScoreFormat: '',
			 selectedScoreFormatName: '',
			 matchScore: '',
			 set1Score: '',
			 set1TiebreakScore: '',
			 set2Score: '',
			 set2TiebreakScore: '',
			 set3Score: '',
			 set3TiebreakScore: '',
			 player1Set1Score: '',
			 player2Set1Score: '',
			 player1Set2Score: '',
			 player2Set2Score: '',
			 player1Set3Score: '',
			 player2Set3Score: '',
			 player1Set1TieBreakScore: '',
			 player2Set1TieBreakScore: '',
			 player1Set2TieBreakScore: '',
			 player2Set2TieBreakScore: '',
			 player1Set3TieBreakScore: '',
			 player2Set3TieBreakScore: '',
			 currentSet: 1,
			 acceptableSet1Scores: ['6-0', '6-1', '6-2', '6-3', '6-4', '7-5', '7-6', '0-6', '1-6', '2-6', '3-6', '4-6', '5-7', '6-7'],
			 acceptableSet1ScoresCondition1: null,
			 InputTieBreakSet1Scores: ['7-6', '6-7'],
			 acceptableTieBreakScoreS1C1: ['7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '0-7', '1-7', '2-7', '3-7', '4-7', '5-7'],
			 acceptableTieBreakScoreS1C2: ['Player1-6', 'Player2-6', 'Difference-2'],
			 Set2Enabled: false,
 
			 acceptableSet2Scores: ['6-0', '6-1', '6-2', '6-3', '6-4', '7-5', '7-6', '0-6', '1-6', '2-6', '3-6', '4-6', '5-7', '6-7'],
			 InputTieBreakSet2Scores: ['7-6', '6-7'],
			 acceptableTieBreakScoreS2C1: ['7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '0-7', '1-7', '2-7', '3-7', '4-7', '5-7'],
			 acceptableTieBreakScoreS2C2: ['Player1-6', 'Player2-6', 'Difference-2'],
			 Set3Enabled: false,
 
			 acceptableSet3Scores: ['6-0', '6-1', '6-2', '6-3', '6-4', '7-5', '7-6', '0-6', '1-6', '2-6', '3-6', '4-6', '5-7', '6-7'],
			 acceptableSet3ScoresCondition1: null,
			 InputTieBreakSet3Scores: ['7-6', '6-7'],
			 acceptableTieBreakScoreS3C1: ['7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '0-7', '1-7', '2-7', '3-7', '4-7', '5-7'],
			 acceptableTieBreakScoreS3C2: ['Player1-6', 'Player2-6', 'Difference-2'],
			 set1Winner: '',
			 set2Winner: '',
			 set3Winner: '',
			 matchWinner: '',
			 scoreFormatRules: {
				 "rule1": {
					 "Name": "3 tie-break sets",
					 "description": document.getElementById('rule1') && document.getElementById('rule1').innerHTML,
					 "selectedScoreFormat": "3 tie-break sets",
					 "acceptableSet1Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					 "acceptableSet1ScoresCondition1": null,
					 "InputTieBreakSet1Scores": ["7-6", "6-7"],
					 "acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set2Enabled": true,
					 "acceptableSet2Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					 "InputTieBreakSet2Scores": ["7-6", "6-7"],
					 "acceptableTieBreakScoreS2C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS2C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set3Enabled": true,
					 "acceptableSet3Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					 "acceptableSet3ScoresCondition1": null,
					 "InputTieBreakSet3Scores": ["7-6", "6-7"],
					 "acceptableTieBreakScoreS3C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS3C2": ["Player1-6", "Player2-6", "Difference-2"]
				 },
				 "rule2": {
					 "Name": "2 tie-break sets + match tie-break",
					 "description": document.getElementById('rule2') && document.getElementById('rule2').innerHTML,
					 "selectedScoreFormat": "2 tie-break sets + match tie-break",
					 "acceptableSet1Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					 "acceptableSet1ScoresCondition1": null,
					 "InputTieBreakSet1Scores": ["7-6", "6-7"],
					 "acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set2Enabled": true,
					 "acceptableSet2Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					 "InputTieBreakSet2Scores": ["7-6", "6-7"],
					 "acceptableTieBreakScoreS2C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS2C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set3Enabled": true,
					 "acceptableSet3Scores": ["10-0", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7", "10-8", "8-10", "7-10", "6-10", "5-10", "4-10", "3-10", "2-10", "1-10", "0-10"],
					 "acceptableSet3ScoresCondition1": ["Player1-9", "Player2-9", "Difference-2"],
					 "InputTieBreakSet3Scores": null,
					 "acceptableTieBreakScoreS3C1": null,
					 "acceptableTieBreakScoreS3C2": null
				 },
				 "rule3":
				 {
					 "Name": "2 FAST4 sets + match tie-break",
					 "description": document.getElementById('rule3') && document.getElementById('rule3').innerHTML,
					 "selectedScoreFormat": "2 FAST4 sets + match tie-break",
					 "acceptableSet1Scores": ["4-0", "4-1", "4-2", "4-3", "0-4", "1-4", "2-4", "3-4"],
					 "acceptableSet1ScoresCondition1": null,
					 "InputTieBreakSet1Scores": ["4-3", "3-4"],
					 "acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set2Enabled": true,
					 "acceptableSet2Scores": ["4-0", "4-1", "4-2", "4-3", "0-4", "1-4", "2-4", "3-4"],
					 "InputTieBreakSet2Scores": ["4-3", "3-4"],
					 "acceptableTieBreakScoreS2C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS2C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set3Enabled": true,
					 "acceptableSet3Scores": ["10-0", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7", "10-8", "8-10", "7-10", "6-10", "5-10", "4-10", "3-10", "2-10", "1-10", "0-10"],
					 "acceptableSet3ScoresCondition1": ["Player1-9", "Player2-9", "Difference-2"],
					 "InputTieBreakSet3Scores": null,
					 "acceptableTieBreakScoreS3C1": null,
					 "acceptableTieBreakScoreS3C2": null
				 },
				 "rule4": {
					 "Name": "1 tie-break set",
					 "description": document.getElementById('rule4') && document.getElementById('rule4').innerHTML,
					 "selectedScoreFormat": "1 tie-break set",
					 "acceptableSet1Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					 "acceptableSet1ScoresCondition1": null,
					 "InputTieBreakSet1Scores": ["7-6", "6-7"],
					 "acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					 "acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					 "Set2Enabled": false,
					 "acceptableSet2Scores": null,
					 "InputTieBreakSet2Scores": null,
					 "acceptableTieBreakScoreS2C1": null,
					 "acceptableTieBreakScoreS2C2": null,
					 "Set3Enabled": false,
					 "acceptableSet3Scores": null,
					 "acceptableSet3ScoresCondition1": null,
					 "InputTieBreakSet3Scores": null,
					 "acceptableTieBreakScoreS3C1": null,
					 "acceptableTieBreakScoreS3C2": null
				 },
				 "rule5": {
					 "Name": "1 match tie-break",
					 "description": document.getElementById('rule5') && document.getElementById('rule5').innerHTML,
					 "selectedScoreFormat": "1 match tie-break",
					 "acceptableSet1Scores": ["10-0", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7", "10-8", "8-10", "7-10", "6-10", "5-10", "4-10", "3-10", "2-10", "1-10", "0-10"],
					 "acceptableSet1ScoresCondition1": ["Player1-9", "Player2-9", "Difference-2"],
					 "InputTieBreakSet1Scores": null,
					 "acceptableTieBreakScoreS1C1": null,
					 "acceptableTieBreakScoreS1C2": null,
					 "Set2Enabled": false,
					 "acceptableSet2Scores": null,
					 "InputTieBreakSet2Scores": null,
					 "acceptableTieBreakScoreS2C1": null,
					 "acceptableTieBreakScoreS2C2": null,
					 "Set3Enabled": false,
					 "acceptableSet3Scores": null,
					 "acceptableSet3ScoresCondition1": null,
					 "InputTieBreakSet3Scores": null,
					 "acceptableTieBreakScoreS3C1": null,
					 "acceptableTieBreakScoreS3C2": null
				 },
				 "rule6": {
					 "Name": "Accept anything",
					 "description": document.getElementById('rule6') && document.getElementById('rule6').innerHTML,
					 "selectedScoreFormat": "Accept anything",
					 "acceptableSet1Scores": 'any',
					 "acceptableSet1ScoresCondition1": null,
					 "InputTieBreakSet1Scores": null,
					 "acceptableTieBreakScoreS1C1": null,
					 "acceptableTieBreakScoreS1C2": null,
					 "Set2Enabled": false,
					 "acceptableSet2Scores": null,
					 "InputTieBreakSet2Scores": null,
					 "acceptableTieBreakScoreS2C1": null,
					 "acceptableTieBreakScoreS2C2": null,
					 "Set3Enabled": false,
					 "acceptableSet3Scores": null,
					 "acceptableSet3ScoresCondition1": null,
					 "InputTieBreakSet3Scores": null,
					 "acceptableTieBreakScoreS3C1": null,
					 "acceptableTieBreakScoreS3C2": null
				 }
			 },
			 playerDataAttributes: {
				 "singlesOpponent": {
					 playerSection: ".player-search-single",
					 favouritePlayerSection: "favourite-player-section",
					 manualPlayerSection: "js-manual-entry-opponent-form",
					 playerSearchSection: "cant-find-opponent-section",
					 searchPlayerAgainBtn: ".js-search-again",
					 showFavouritesBtn: ".js-show-favourites-manual",
					 playerFirstName: "#firstName",
					 playerLastName: "#lastName",
					 nextBtn: ".lta-btn-player-selected",
					 noOpponentBtn: ".js-search-no-opponent",
					 showFavouritesSearchBtn: ".js-show-favourites-search",
					 playerSearchBtnLink: ".search-player-btn-link",
					 playerList: ".js-favourite-singles-player-list",
					 playerListTemplateName: "recentPlayerListTemplate",
					 selectedPlayerSearchType: "Opponent"
				 },
				 "doublesPartner": {
					 playerSection: ".player-search-doubles-partner",
					 favouritePlayerSection: "favourite-player-partner-section",
					 manualPlayerSection: "js-manual-entry-partner-form",
					 playerSearchSection: "cant-find-partner-section",
					 searchPlayerAgainBtn: ".js-search-partner-again",
					 showFavouritesBtn: ".js-show-favourites-partner-manual",
					 playerFirstName: "#partnerFirstName",
					 playerLastName: "#partnerLastName",
					 nextBtn: ".lta-btn-partner-player-selected",
					 noOpponentBtn: ".js-search-no-partner",
					 showFavouritesSearchBtn: ".js-show-favourites-partner-search",
					 playerSearchBtnLink: ".search-player-partner-btn-link",
					 playerList: ".js-favourite-partner-player-list",
					 playerListTemplateName: "recentPartnerPlayerListTemplate",
					 selectedPlayerSearchType: "Partner"
				 },
				 "doublesOpponent1": {
					 playerSection: ".player-search-doubles-opponents1",
					 favouritePlayerSection: "favourite-player-doubles-opponent1-section",
					 manualPlayerSection: "js-manual-entry-doubles-opponent1-form",
					 playerSearchSection: "cant-find-doubles-opponent1-section",
					 searchPlayerAgainBtn: ".js-search-opponent1-again",
					 showFavouritesBtn: ".js-show-favourites-opponent1-manual",
					 playerFirstName: "#opponent1FirstName",
					 playerLastName: "#opponent1LastName",
					 nextBtn: ".lta-btn-opponent1-player-selected",
					 noOpponentBtn: ".js-search-no-opponent1",
					 showFavouritesSearchBtn: ".js-show-favourites-opponent1-search",
					 playerSearchBtnLink: ".search-player-opponent1-btn-link",
					 playerList: ".js-favourite-opponent1-player-list",
					 playerListTemplateName: "recentOpponent1PlayerListTemplate",
					 selectedPlayerSearchType: "Opponent1"
				 },
				 "doublesOpponent2": {
					 playerSection: ".player-search-doubles-opponents2",
					 favouritePlayerSection: "favourite-player-doubles-opponent2-section",
					 manualPlayerSection: "js-manual-entry-doubles-opponent2-form",
					 playerSearchSection: "cant-find-doubles-opponent2-section",
					 searchPlayerAgainBtn: ".js-search-opponent2-again",
					 showFavouritesBtn: ".js-show-favourites-opponent2-manual",
					 playerFirstName: "#opponent2FirstName",
					 playerLastName: "#opponent2LastName",
					 nextBtn: ".lta-btn-opponent2-player-selected",
					 noOpponentBtn: ".js-search-no-opponent2",
					 showFavouritesSearchBtn: ".js-show-favourites-opponent2-search",
					 playerSearchBtnLink: ".search-player-opponent2-btn-link",
					 playerList: ".js-favourite-opponent2-player-list",
					 playerListTemplateName: "recentOpponent2PlayerListTemplate",
					 selectedPlayerSearchType: "Opponent2"
				 }
			 }
		 };
		 this._wrapper = undefined;
		 this._modal = undefined;
		 this._sections = undefined;
		 this._gameSections = undefined;
		 this._stepSections = undefined;
		 this._isRecommended = false;
		 this._matchScoreForm;
		 this._msfv;
		 this._addNewBtn = undefined;
		 this._showNextBtn = undefined;
		 this._dedupModal = undefined;
		 this._exitModal = undefined;
		 this._defaultsModal = undefined;
		 this._referralModal = undefined;
		 this._loaderModal = undefined;
		 this._modalTriggerSSBtn = undefined;
		 this.initiateSection();
		 this.disablePickerManualEntry();
		 this.ssVenueSearchEl = globalselfSubmissionVenueSearch;
 
		 this.ssPlayerSearchEl = SelfSubmissionPlayerSearch.getInstance(document.querySelector('.lta-player-ss-search.js-singles-player-search')) || new SelfSubmissionPlayerSearch(document.querySelector('.lta-player-ss-search.js-singles-player-search'));
		 this.ssPartnerSearchEl = SelfSubmissionPlayerSearch.getInstance(document.querySelector('.lta-player-ss-search.js-partner-player-search')) || new SelfSubmissionPlayerSearch(document.querySelector('.lta-player-ss-search.js-partner-player-search'));
		 this.ssOpponent1SearchEl = SelfSubmissionPlayerSearch.getInstance(document.querySelector('.lta-player-ss-search.js-opponent1-player-search')) || new SelfSubmissionPlayerSearch(document.querySelector('.lta-player-ss-search.js-opponent1-player-search'));
		 this.ssOpponent2SearchEl = SelfSubmissionPlayerSearch.getInstance(document.querySelector('.lta-player-ss-search.js-opponent2-player-search')) || new SelfSubmissionPlayerSearch(document.querySelector('.lta-player-ss-search.js-opponent1-player-search'));
	 }
 
	 initiateSection() {
		 this._wrapper = SelectorEngine.findOne('#self-submission-modal');
		 if(!this._wrapper) {
			return;
		 }
		 this._successModal = new Modal(document.querySelector('#js-success-modal'), {});
		 this._defaultsModal = new Modal(document.querySelector('#js-defaults-modal'), {});
		 this._modal = new Modal(document.querySelector('#self-submission-modal'), {});
		 this._modalTriggerSSBtn = SelectorEngine.findOne('.js-trigger-self-submission');
		 const closeModal = document.querySelector('#exit-self-submission');
		 const deduplicationModal = document.querySelector('#self-submission-deduplication-check');
		 this._referralModal = new Modal(document.querySelector('#js-referral-modal'), {});
		 this._loaderModal = new Modal(document.querySelector('#js-loader-modal'), {});
 
		 this._exitModal = new Modal(closeModal, { backdrop: 'static' });
		 this._dedupModal = new Modal(deduplicationModal, {});
		 const closeModalButton = SelectorEngine.findOne('.js-close-self-submission', this._wrapper);
		 const closeSuccessModalBtn = SelectorEngine.findOne('.js-exit-success-modal');
		 const closeDefaultsBtn = SelectorEngine.findOne('.js-close-defaults-btn');
		 const saveDefaultsBtn = SelectorEngine.findOne('.js-save-defaults-btn');
		 const closeReferralBtn = SelectorEngine.findOne('.js-exit-referral-modal');
		 const ltaSectionContent = SelectorEngine.findOne(".js-lta-section-content", this._wrapper);
		 const continueCta = SelectorEngine.find('.js-exit-self-submission');
		 const exitCta = SelectorEngine.find('.js-self-submission-exit');
		 const nextSectionCtas = SelectorEngine.find('.js-next-section', this._wrapper);
		 const previousCtas = SelectorEngine.find('.js-self-submision-back', this._wrapper);
		 const previousstepCtas = SelectorEngine.find('.js-self-submission-back-step', this._wrapper);
		 this._sections = SelectorEngine.find('.content-container', this._wrapper);
		 this._stepSections = SelectorEngine.find('.steps-container', this._wrapper);
		 const forms = SelectorEngine.find('.lta-content--form-element', this._wrapper);
		 const picker = SelectorEngine.findOne(".js-self-submission-date", this._wrapper);
		 const invitePlayerBtn = SelectorEngine.findOne('.js-invite-players-btn');
		 const editDefaultsBtn = SelectorEngine.findOne('.js-edit-default-btn');
		 const singlesCopyReferralLinkBtn = SelectorEngine.findOne('.js-singles-copy-referral-link');
		 const partnerCopyReferralLinkBtn = SelectorEngine.findOne('.js-partner-copy-referral-link');
		 const opponent1CopyReferralLinkBtn = SelectorEngine.findOne('.js-opponent1-copy-referral-link');
		 const opponent2CopyReferralLinkBtn = SelectorEngine.findOne('.js-opponent2-copy-referral-link');
		//  const picker = document.querySelector(".lta-section-content duet-date-picker");
 
		 const singlesInstagramReferralBtn = SelectorEngine.findOne('#singles-referral-instagram');
		 const partnerInstagramReferralBtn = SelectorEngine.findOne('#partner-referral-instagram');
		 const opponent1InstagramReferralBtn = SelectorEngine.findOne('#opponent1-referral-instagram');
		 const opponent2InstagramReferralBtn = SelectorEngine.findOne('#opponent2-referral-instagram');
 
		 const editPlayerBtn = SelectorEngine.findOne('.js-edit-players-details-trigger');
		 const editVenueBtn = SelectorEngine.findOne('.js-edit-venue-trigger');
		 const editDateBtn = SelectorEngine.findOne('.js-edit-date-trigger');
		 const editScoreBtn = SelectorEngine.findOne('.js-edit-score-trigger');
		 const editMatchDetailsBtn = SelectorEngine.findOne('.js-edit-match-details-trigger');
 
		 // Venue search sections
		 const favouriteVenueForm = document.getElementById('favourite-venues-section', this._wrapper);
		 const cantFindVenueForm = document.getElementById('cant-find-venues-section', this._wrapper);
 
		 const noOpponentBtn = SelectorEngine.findOne('.js-search-no-opponent', this._wrapper);
		 const noPartnerBtn = SelectorEngine.findOne('.js-search-no-partner', this._wrapper);
		 const noOpponent1Btn = SelectorEngine.findOne('.js-search-no-opponent1', this._wrapper);
		 const noOpponent2Btn = SelectorEngine.findOne('.js-search-no-opponent2', this._wrapper);
 
		 const searchAgainBtn = SelectorEngine.findOne('.js-search-again', this._wrapper);
		 const searchPartnerAgainBtn = SelectorEngine.findOne('.js-search-partner-again', this._wrapper);
		 const searchOpponent1AgainBtn = SelectorEngine.findOne('.js-search-opponent1-again', this._wrapper);
		 const searchOpponent2AgainBtn = SelectorEngine.findOne('.js-search-opponent2-again', this._wrapper);
 
		 const searchVenueBtnLink = SelectorEngine.findOne('.search-venue-btn-link', this._wrapper);
		 const searchPlayerBtnLink = SelectorEngine.findOne('.search-player-btn-link', this._wrapper);
		 const searchPlayerPartnerBtnLink = SelectorEngine.findOne('.search-player-partner-btn-link', this._wrapper);
		 const searchPlayerOpponent1BtnLink = SelectorEngine.findOne('.search-player-opponent1-btn-link', this._wrapper);
		 const searchPlayerOpponent2BtnLink = SelectorEngine.findOne('.search-player-opponent2-btn-link', this._wrapper);
 
		 const closeDedupModalBtn = SelectorEngine.findOne('.js-self-submission-dedup-cancel');
		 const addDedupModalBtn = SelectorEngine.findOne('.js-self-submission-dedup-continue');
		 const showFavouritesVenueSearchBtn = SelectorEngine.findOne('.js-show-favourites-venue-search', this._wrapper);
		 const showFavouritesSearchBtn = SelectorEngine.findOne('.js-show-favourites-search', this._wrapper);
		 const showFavouritesPartnerSearchBtn = SelectorEngine.findOne('.js-show-favourites-partner-search', this._wrapper);
		 const showFavouritesOpponent1SearchBtn = SelectorEngine.findOne('.js-show-favourites-opponent1-search', this._wrapper);
		 const showFavouritesOpponent2SearchBtn = SelectorEngine.findOne('.js-show-favourites-opponent2-search', this._wrapper);
 
		 const showFavouritesManualBtn = SelectorEngine.findOne('.js-show-favourites-manual', this._wrapper);
		 const showFavouritesPartnerManualBtn = SelectorEngine.findOne('.js-show-favourites-partner-manual', this._wrapper);
		 const showFavouritesOpponent1ManualBtn = SelectorEngine.findOne('.js-show-favourites-opponent1-manual', this._wrapper);
		 const showFavouritesOpponent2ManualBtn = SelectorEngine.findOne('.js-show-favourites-opponent2-manual', this._wrapper);
 
		 const submitScoreBtn = SelectorEngine.findOne('.js-submit-score', this._wrapper);
 
		 // match score section
		 this._matchScoreForm = document.getElementById('match-score');
		 const scoreFormatElement = SelectorEngine.findOne('.js-lta-score-select', this._wrapper);
		 const scoreFormatTooltipContent = SelectorEngine.findOne('.js-lta-tooltip__content', this._wrapper);
		 const matchScoreContainer = SelectorEngine.findOne('.match-score-container', this._wrapper);
		 const player1_set1_score_input = document.getElementById('player1-set1-score-input');
		 const player2_set1_score_input = document.getElementById('player2-set1-score-input');
		 const player1_set2_score_input = document.getElementById('player1-set2-score-input');
		 const player2_set2_score_input = document.getElementById('player2-set2-score-input');
		 const player1_set3_score_input = document.getElementById('player1-set3-score-input');
		 const player2_set3_score_input = document.getElementById('player2-set3-score-input');
		 const player1_set1_tieBreak_score_input = document.getElementById('player1-set1-tie-break-score-input');
		 const player2_set1_tieBreak_score_input = document.getElementById('player2-set1-tie-break-score-input');
		 const player1_set2_tieBreak_score_input = document.getElementById('player1-set2-tie-break-score-input');
		 const player2_set2_tieBreak_score_input = document.getElementById('player2-set2-tie-break-score-input');
		 const player1_set3_tieBreak_score_input = document.getElementById('player1-set3-tie-break-score-input');
		 const player2_set3_tieBreak_score_input = document.getElementById('player2-set3-tie-break-score-input');
		 const set2Container = SelectorEngine.findOne('.set2-container', this._wrapper);
		 const set3Container = SelectorEngine.findOne('.set3-container', this._wrapper);
		 const tieBreakSet1Container = SelectorEngine.findOne('.tie-break-set1-container', this._wrapper);
		 const tieBreakSet2Container = SelectorEngine.findOne('.tie-break-set2-container', this._wrapper);
		 const tieBreakSet3Container = SelectorEngine.findOne('.tie-break-set3-container', this._wrapper);
		 this._addNewBtn = SelectorEngine.findOne('.lta-add--set');
		 this._showNextBtn = document.querySelector('.match-score-container') && document.querySelector('.match-score-container').querySelector('.js-next-section');
 
 
		 // date picker config
		 const last2weeks = [...Array(16)].map((_, i) => { const d = new Date(); d.setDate(d.getDate() - i); return d })
		 if (picker) {
			 picker.setAttribute("min", last2weeks[14].toISOString().split('T')[0]);
			 picker.setAttribute("max", new Date(Date.now()).toISOString().split('T')[0]);
		 }
 
		 EventHandler.on(editDefaultsBtn, 'click', () => {
			 document.getElementById('defaults-game-param-section').classList.add('u-hidden');
			 document.getElementById('manual-game-param-section').classList.remove('u-hidden');
		 });
 
		 // button where no opponent is available in player search
		 EventHandler.on(noOpponentBtn, 'click', () => {
			 this.displayPlayerSection('cantFindSingleOpponent', this.state.playerDataAttributes.singlesOpponent);
		 });
 
		 // Partner no opponent button
		 EventHandler.on(noPartnerBtn, 'click', () => {
			 this.displayPlayerSection('cantFindSingleOpponent', this.state.playerDataAttributes.doublesPartner);
		 });
 
		 // Opponent 1 no opponent button
		 EventHandler.on(noOpponent1Btn, 'click', () => {
			 this.displayPlayerSection('cantFindSingleOpponent', this.state.playerDataAttributes.doublesOpponent1);
		 });
 
		 // opponent 2 no opponent button
		 EventHandler.on(noOpponent2Btn, 'click', () => {
			 this.displayPlayerSection('cantFindSingleOpponent', this.state.playerDataAttributes.doublesOpponent2);
		 });
 
		 // Singles Search player again
		 EventHandler.on(searchAgainBtn, 'click', () => {
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.singlesOpponent);
		 });
 
		 // Partner Search player again
		 EventHandler.on(searchPartnerAgainBtn, 'click', () => {
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.doublesPartner);
		 });
 
		 // Opponent 1 Search player again
		 EventHandler.on(searchOpponent1AgainBtn, 'click', () => {
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.doublesOpponent1);
		 });
 
		 // Opponent 2 Search player again
		 EventHandler.on(searchOpponent2AgainBtn, 'click', () => {
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.doublesOpponent2);
		 });
 
		 // From venue search section go to favourite section
		 EventHandler.on(showFavouritesVenueSearchBtn, 'click', () => {
			 favouriteVenueForm.classList.remove("u-hidden");
			 cantFindVenueForm.classList.add("u-hidden");
			 searchVenueBtnLink.classList.remove("u-hidden");
			 SelectorEngine.findOne('.lta-btn-without-venue').classList.remove("u-hidden");
		 });
 
		 // From player search section go to favourite section
		 EventHandler.on(showFavouritesSearchBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.singlesOpponent);
		 });
 
		 // From partner search section go to favourite section
		 EventHandler.on(showFavouritesPartnerSearchBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.doublesPartner);
		 });
 
		 // From opponent1 search section go to favourite section
		 EventHandler.on(showFavouritesOpponent1SearchBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.doublesOpponent1);
		 });
 
		 // From opponent2 search section go to favourite section
		 EventHandler.on(showFavouritesOpponent2SearchBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.doublesOpponent2);
		 });
 
 
		 // From manual player selection section go to favourite section
		 EventHandler.on(showFavouritesManualBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.singlesOpponent);
		 });
 
		 // From manual partner player selection section go to favourite section
		 EventHandler.on(showFavouritesPartnerManualBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.doublesPartner);
		 });
 
		 // From manual opponent 1 player selection section go to favourite section
		 EventHandler.on(showFavouritesOpponent1ManualBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.doublesOpponent1);
		 });
 
		 // From manual opponent 2 player selection section go to favourite section
		 EventHandler.on(showFavouritesOpponent2ManualBtn, 'click', () => {
			 this.displayPlayerSection('showFavourites', this.state.playerDataAttributes.doublesOpponent2);
		 });
 
		 // Date Picker show next section
		 EventHandler.on(picker, "duetChange", (e) => {
			 this.state.dateValue = e.target.value;
			 const favPlayerList = document.querySelector('.js-favourite-venues-list');
			 if (this.state.recentVenuesListTemplate) {
				 favPlayerList.append(this.state.recentVenuesListTemplate);
				 favouriteVenueForm.classList.remove('u-hidden');
				 setTimeout(() => favouriteVenueForm.scrollIntoView(), 600);
			 } else {
				 favouriteVenueForm.classList.add('u-hidden');
				 cantFindVenueForm.classList.remove('u-hidden');
				 showFavouritesVenueSearchBtn.classList.add('u-hidden');
				 cantFindVenueForm.scrollIntoView();
			 }
		 });
 
		 EventHandler.on(this._modalTriggerSSBtn, 'click', () => {
			 this.state.myContactId = document.getElementById('self-submission-data-attr').getAttribute('data-ss-primary-contact-id');
			 this.state.myContactName = document.getElementById('self-submission-data-attr').getAttribute('data-ss-primary-givenname') + ' ' + document.getElementById('self-submission-data-attr').getAttribute('data-ss-primary-surname');
			 this.state.myGender = document.getElementById('self-submission-data-attr').getAttribute('data-ss-primary-gender');
			 //Show Loader
			 this.showLoader(true);
			 // Register player self submission started in mulesoft
			 this.recordPlayerProcess();
			 // Fetch Favourite players and generate html template for singles and doubles players;
			 this.getFavouritePlayers();
			 // Fetch default params
			 this.getDefaults();
			 // Fetch default Venues
			 this.getDefaultVenues();
			 this._modal.show();
			 // hide Loader
			 this.showLoader(false);
		 });
 
		 EventHandler.on(addDedupModalBtn, 'click', () => {
			this._dedupModal.hide();
		 });
 
		 EventHandler.on(closeDedupModalBtn, 'click', () => {
			 this.state.isSubmitted = true;
			 this._dedupModal.hide();
			 this._modal.hide();
			 this.exitJourney();
		 });
 
		 EventHandler.on(closeModalButton, 'click', () => {
			 this._isRecommended = true;
			 this.state.isSubmitted = true;
			 this._modal.hide();
			 this.exitJourney();
			 this.state.section = this.state.section - this.state.section;
		 });
 
		 EventHandler.on(closeSuccessModalBtn, 'click', () => {
			 this._isRecommended = true;
			 this.state.isSubmitted = true;
			 this._successModal.hide();
			 this._modal.hide();
			 this.exitJourney();
		 });
 
		 EventHandler.on(closeDefaultsBtn, 'click', () => {
			 this._defaultsModal.hide();
		 });
 
		 EventHandler.on(saveDefaultsBtn, 'click', () => {
			 this.saveDefaults();
		 });
 
		 EventHandler.on(closeReferralBtn, 'click', () => {
			 this._referralModal.hide();
		 });
 
		 EventHandler.on(singlesCopyReferralLinkBtn, 'click', () => {
			 let copyLink = document.getElementById('singles-referral-value').value;
			 navigator.clipboard.writeText(copyLink);
		 });
 
		 EventHandler.on(partnerCopyReferralLinkBtn, 'click', () => {
			 let copyLink = document.getElementById('partner-referral-value').value;
			 navigator.clipboard.writeText(copyLink);
		 });
 
		 EventHandler.on(opponent1CopyReferralLinkBtn, 'click', () => {
			 let copyLink = document.getElementById('opponent1-referral-value').value;
			 navigator.clipboard.writeText(copyLink);
		 });
 
		 EventHandler.on(opponent2CopyReferralLinkBtn, 'click', () => {
			 let copyLink = document.getElementById('opponent2-referral-value').value;
			 navigator.clipboard.writeText(copyLink);
		 });
 
		 EventHandler.on(singlesInstagramReferralBtn, 'click', () => {
			 let copyLink = document.getElementById('singles-referral-value').value;
			 navigator.clipboard.writeText(copyLink).then(function () {
				 console.log('Copying to clipboard was successful!');
				 window.open(document.getElementById('referral-modal-body').getAttribute('data-ss-instagram-url'));
			 }, function (err) {
				 console.error('Could not copy text: ', err);
			 });
		 });
 
		 EventHandler.on(partnerInstagramReferralBtn, 'click', () => {
			 let copyLink = document.getElementById('partner-referral-value').value;
			 navigator.clipboard.writeText(copyLink).then(function () {
				 console.log('Copying to clipboard was successful!');
				 window.open(document.getElementById('referral-modal-body').getAttribute('data-ss-instagram-url'));
			 }, function (err) {
				 console.error('Could not copy text: ', err);
			 });
		 });
 
 
		 EventHandler.on(opponent1InstagramReferralBtn, 'click', () => {
			 let copyLink = document.getElementById('opponent1-referral-value').value;
			 navigator.clipboard.writeText(copyLink).then(function () {
				 console.log('Copying to clipboard was successful!');
				 window.open(document.getElementById('referral-modal-body').getAttribute('data-ss-instagram-url'));
			 }, function (err) {
				 console.error('Could not copy text: ', err);
			 });
		 });
 
		 EventHandler.on(opponent2InstagramReferralBtn, 'click', () => {
			 let copyLink = document.getElementById('opponent2-referral-value').value;
			 navigator.clipboard.writeText(copyLink).then(function () {
				 console.log('Copying to clipboard was successful!');
				 window.open(document.getElementById('referral-modal-body').getAttribute('data-ss-instagram-url'));
			 }, function (err) {
				 console.error('Could not copy text: ', err);
			 });
		 });
 
 
		 EventHandler.on(searchVenueBtnLink, 'click', () => {
			 document.querySelectorAll('.js-favourite-venues-list input').forEach(el => el.checked = false);
			 document.querySelector('.search-venue-btn-link').classList.add('u-hidden');
			 document.querySelector('.lta-btn-venue-selected').classList.add('u-hidden');
			 favouriteVenueForm.classList.add('u-hidden');
			 cantFindVenueForm.classList.remove('u-hidden');
		 });
 
		 // single search player button link
		 EventHandler.on(searchPlayerBtnLink, 'click', () => {
			 document.querySelectorAll('.js-favourite-singles-player-list input').forEach(el => el.checked = false);
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.singlesOpponent);
		 });
 
		 // partner search player button link
		 EventHandler.on(searchPlayerPartnerBtnLink, 'click', () => {
			 document.querySelectorAll('.js-favourite-partner-player-list input').forEach(el => el.checked = false);
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.doublesPartner);
		 });
 
		 // opponent 1 search player button link
		 EventHandler.on(searchPlayerOpponent1BtnLink, 'click', () => {
			 document.querySelectorAll('.js-favourite-opponent1-player-list input').forEach(el => el.checked = false);
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.doublesOpponent1);
		 });
 
		 // opponent 2 search player button link
		 EventHandler.on(searchPlayerOpponent2BtnLink, 'click', () => {
			 document.querySelectorAll('.js-favourite-opponent2-player-list input').forEach(el => el.checked = false);
			 this.displayPlayerSection('singlesPlayerSearchAgain', this.state.playerDataAttributes.doublesOpponent2);
		 });
 
		 EventHandler.on(submitScoreBtn, 'click', () => {
			 submitScoreBtn.disabled = true;
			 this.submitScore();
		 });
 
 
		 // Data to show on Referral Popup
		 EventHandler.on(invitePlayerBtn, 'click', () => {
			 if (this.state.matchFormat == 'Singles') {
				 this.state.partnerFirstName = ''; this.state.partnerLastName = ''; document.querySelector('.partner-referral-container').classList.add('u-hidden');
				 this.state.opponent1FirstName = ''; this.state.opponent1LastName = ''; document.querySelector('.opponent1-referral-container').classList.add('u-hidden');
				 this.state.opponent2FirstName = ''; this.state.opponent2LastName = ''; document.querySelector('.opponent2-referral-container').classList.add('u-hidden');
				 if (this.state.playerFirstName && this.state.playerLastName) {
					 document.querySelector('.singles-referral-container').classList.remove('u-hidden');
					 document.querySelector('.singles-referral-container').querySelector('h5').innerText = this.state.playerFirstName + ' ' + this.state.playerLastName;
					 document.getElementById('singles-referral-value').value = window.location.origin + document.getElementById('self-submission-data-attr').getAttribute('data-ss-refer-url') + '?code=' + `${this.state.singlesReferralCode}-${this.state.selectedPlayer[0].firstname}-Opponent`;
 
					 // For singles email link
					 let formattedBody = document.getElementById('referral-modal-body').getAttribute('data-ss-email-body') + '%0A' + document.getElementById('singles-referral-value').value;
					 let mailToLink = 'mailto:?subject=' + document.getElementById('referral-modal-body').getAttribute('data-ss-email-subject') + '&body=' + formattedBody;
					 document.getElementById('singles-referral-email').href = mailToLink;
 
					 // For singles whatsapp link
					 var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
					 if (isMobile) {
						 let mobileLink = 'https://api.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('singles-referral-whatsapp').href = mobileLink;
					 } else {
						 let webLink = 'https://web.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('singles-referral-whatsapp').href = webLink;
					 }
 
					 // For singles Facebook link
					 let facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + document.getElementById('singles-referral-value').value;
					 document.getElementById('singles-referral-facebook').href = facebookLink;
				 } else {
					 document.querySelector('.singles-referral-container').classList.add('u-hidden');
				 }
			 }
			 else if (this.state.matchFormat == 'Doubles') {
				 document.querySelector('.singles-referral-container').classList.add('u-hidden');
				 this.state.playerFirstName = '';
				 this.state.playerLastName = '';
				 if (this.state.partnerFirstName && this.state.partnerLastName) {
					 document.querySelector('.partner-referral-container').classList.remove('u-hidden');
					 document.querySelector('.partner-referral-container').querySelector('h5').innerText = this.state.partnerFirstName + ' ' + this.state.partnerLastName;
					 document.getElementById('partner-referral-value').value = window.location.origin + document.getElementById('self-submission-data-attr').getAttribute('data-ss-refer-url') + '?code=' + `${this.state.partnerRefferalCode}-${this.state.selectedPartner[0].firstname}-Partner`;
 
					 // For partner email link
					 let formattedBody = document.getElementById('referral-modal-body').getAttribute('data-ss-email-body') + '%0A' + document.getElementById('partner-referral-value').value;
					 let mailToLink = 'mailto:?subject=' + document.getElementById('referral-modal-body').getAttribute('data-ss-email-subject') + '&body=' + formattedBody;
					 document.getElementById('partner-referral-email').href = mailToLink;
 
					 // For partner whatsapp link
					 var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
					 if (isMobile) {
						 let mobileLink = 'https://api.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('partner-referral-whatsapp').href = mobileLink;
					 } else {
						 let webLink = 'https://web.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('partner-referral-whatsapp').href = webLink;
					 }
 
					 // For partner Facebook link
					 let facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + document.getElementById('partner-referral-value').value;
					 document.getElementById('partner-referral-facebook').href = facebookLink;
				 } else {
					 document.querySelector('.partner-referral-container').classList.add('u-hidden');
				 }
				 if (this.state.opponent1FirstName && this.state.opponent1LastName) {
					 document.querySelector('.opponent1-referral-container').classList.remove('u-hidden');
					 document.querySelector('.opponent1-referral-container').querySelector('h5').innerText = this.state.opponent1FirstName + ' ' + this.state.opponent1LastName;
					 document.getElementById('opponent1-referral-value').value = window.location.origin + document.getElementById('self-submission-data-attr').getAttribute('data-ss-refer-url') + '?code=' + `${this.state.opponent1ReferralCode}-${this.state.selectedOpponent1[0].firstname}-Opponent1`;
 
					 // For opponent1 email link
					 let formattedBody = document.getElementById('referral-modal-body').getAttribute('data-ss-email-body') + '%0A' + document.getElementById('opponent1-referral-value').value;
					 let mailToLink = 'mailto:?subject=' + document.getElementById('referral-modal-body').getAttribute('data-ss-email-subject') + '&body=' + formattedBody;
					 document.getElementById('opponent1-referral-email').href = mailToLink;
 
					 // For opponent1 whatsapp link
					 var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
					 if (isMobile) {
						 let mobileLink = 'https://api.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('opponent1-referral-whatsapp').href = mobileLink;
					 } else {
						 let webLink = 'https://web.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('opponent1-referral-whatsapp').href = webLink;
					 }
 
					 // For opponent1 Facebook link
					 let facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + document.getElementById('opponent1-referral-value').value;
					 document.getElementById('opponent1-referral-facebook').href = facebookLink;
				 } else {
					 document.querySelector('.opponent1-referral-container').classList.add('u-hidden');
				 }
				 if (this.state.opponent2FirstName && this.state.opponent2LastName) {
					 document.querySelector('.opponent2-referral-container').classList.remove('u-hidden');
					 document.querySelector('.opponent2-referral-container').querySelector('h5').innerText = this.state.opponent2FirstName + ' ' + this.state.opponent2LastName;
					 document.getElementById('opponent2-referral-value').value = window.location.origin + document.getElementById('self-submission-data-attr').getAttribute('data-ss-refer-url') + '?code=' + `${this.state.opponent2ReferralCode}-${this.state.selectedOpponent2[0].firstname}-Opponent2`;
 
					 // For opponent2 email link
					 let formattedBody = document.getElementById('referral-modal-body').getAttribute('data-ss-email-body') + '%0A' + document.getElementById('opponent2-referral-value').value;
					 let mailToLink = 'mailto:?subject=' + document.getElementById('referral-modal-body').getAttribute('data-ss-email-subject') + '&body=' + formattedBody;
					 document.getElementById('opponent2-referral-email').href = mailToLink;
 
					 // For opponent2 whatsapp link
					 var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
					 if (isMobile) {
						 let mobileLink = 'https://api.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('opponent2-referral-whatsapp').href = mobileLink;
					 } else {
						 let webLink = 'https://web.whatsapp.com/send?text=' + formattedBody;
						 document.getElementById('opponent2-referral-whatsapp').href = webLink;
					 }
 
					 // For opponent2 Facebook link
					 let facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + document.getElementById('opponent2-referral-value').value;
					 document.getElementById('opponent2-referral-facebook').href = facebookLink;
				 } else {
					 document.querySelector('.opponent2-referral-container').classList.add('u-hidden');
				 }
			 }
			 this._referralModal.show();
		 })
 
		 EventHandler.on(scoreFormatElement, 'change', (e) => {
			 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
			 document.querySelector('.self-submission-score-error-message').innerText = '';
			 this._selectedScoreFormat = e.currentTarget.querySelector('.lta-select__selected').innerText;
			 let selectedRuleId = e.currentTarget.querySelector('.lta-select__item--selected').getAttribute('data-ss-id');
			 this.state.selectedScoreFormatName = this.state.scoreFormatRules[selectedRuleId].selectedScoreFormat;
			 let description = this.state.scoreFormatRules[selectedRuleId].description;
			 this.showScoreFormatSelectedSection(selectedRuleId);
			 if (this.state.selectedScoreFormat !== selectedRuleId) {
				 this.state.set1Score = '';
				 this.state.set1TiebreakScore = '';
				 this.state.set2Score = '';
				 this.state.set2TiebreakScore = '';
				 this.state.set3Score = '';
				 this.state.set3TiebreakScore = '';
				 this.state.player1Set2Score = '';
				 this.state.player2Set2Score = '';
				 this.state.player1Set3Score = '';
				 this.state.player2Set3Score = '';
				 this.state.player1Set1TieBreakScore = '';
				 this.state.player2Set1TieBreakScore = '';
				 this.state.player1Set2TieBreakScore = '';
				 this.state.player2Set2TieBreakScore = '';
				 this.state.player1Set3TieBreakScore = '';
				 this.state.player2Set3TieBreakScore = '';
				 scoreFormatTooltipContent.innerHTML = description;
				 player1_set1_score_input.value = '';
				 player2_set1_score_input.value = '';
				 if (player1_set2_score_input != null) player1_set2_score_input.value = '';
				 if (player2_set2_score_input != null) player2_set2_score_input.value = '';
				 if (player1_set3_score_input != null) player1_set3_score_input.value = '';
				 if (player2_set3_score_input != null) player2_set3_score_input.value = '';
				 if (player1_set1_tieBreak_score_input != null) player1_set1_tieBreak_score_input.value = '';
				 if (player2_set1_tieBreak_score_input != null) player2_set1_tieBreak_score_input.value = '';
				 if (player1_set2_tieBreak_score_input != null) player1_set2_tieBreak_score_input.value = '';
				 if (player2_set2_tieBreak_score_input != null) player2_set2_tieBreak_score_input.value = '';
				 if (player1_set3_tieBreak_score_input != null) player1_set3_tieBreak_score_input.value = '';
				 if (player2_set3_tieBreak_score_input != null) player2_set3_tieBreak_score_input.value = '';
				 matchScoreContainer.querySelector('.js-next-section').classList.add('u-hidden');
				 this._addNewBtn.classList.remove('u-hidden');
				 set2Container && set2Container.classList.add('u-hidden');
				 set3Container && set3Container.classList.add('u-hidden');
				 tieBreakSet1Container && tieBreakSet1Container.classList.add('u-hidden');
				 tieBreakSet2Container && tieBreakSet2Container.classList.add('u-hidden');
				 tieBreakSet3Container && tieBreakSet3Container.classList.add('u-hidden');
			 }
			 matchScoreContainer.classList.remove('u-hidden');
			 document.querySelector('.match-score-tooltip-select').classList.remove('u-hidden');
			 document.querySelector('.lta-add--set').scrollIntoView();
		 });
 
		 // new function to hide next siblings till the last section and clear input values.
		 EventHandler.on(player1_set1_score_input, 'change', (e) => {
			 if (this.state.player1Set1Score !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [set2Container, set3Container, tieBreakSet1Container, tieBreakSet2Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(true, true, true, true, true);
			 }
			 this.state.currentSet = 1;
			 this.state.player1Set1Score = e.target.value;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player2_set1_score_input, 'change', (e) => {
			 if (this.state.player2Set1Score !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [set2Container, set3Container, tieBreakSet1Container, tieBreakSet2Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(true, true, true, true, true);
			 }
			 this.state.player2Set1Score = e.target.value;
			 this.state.currentSet = 1;
			 set2Container.classList.add('u-hidden');
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player1_set2_score_input, 'change', (e) => {
			 if (this.state.player1Set2Score !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [tieBreakSet2Container, set3Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, false, true, true, true);
			 }
			 this.state.player1Set2Score = e.target.value;
			 this.state.currentSet = 2;
			 set3Container.classList.add('u-hidden');
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player2_set2_score_input, 'change', (e) => {
			 if (this.state.player2Set2Score !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [tieBreakSet2Container, set3Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, false, true, true, true);
			 }
			 this.state.player2Set2Score = e.target.value;
			 this.state.currentSet = 2;
			 set3Container.classList.add('u-hidden');
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player1_set3_score_input, 'change', (e) => {
			 if (this.state.player1Set3Score !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, false, false, false, true);
			 }
			 this.state.player1Set3Score = e.target.value;
			 this.state.currentSet = 3;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player2_set3_score_input, 'change', (e) => {
			 if (this.state.player2Set3Score !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, false, false, false, true);
			 }
			 this.state.player2Set3Score = e.target.value;
			 this.state.currentSet = 3;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player1_set1_tieBreak_score_input, 'change', (e) => {
			 if (this.state.player1Set1TieBreakScore !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [set2Container, set3Container, tieBreakSet2Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, true, true, true, true);
 
			 }
			 this.state.player1Set1TieBreakScore = e.target.value;
			 this.state.currentSet = 1;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player2_set1_tieBreak_score_input, 'change', (e) => {
			 if (this.state.player2Set1TieBreakScore !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [set2Container, set3Container, tieBreakSet2Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, true, true, true, true);
			 }
			 this.state.player2Set1TieBreakScore = e.target.value;
			 this.state.currentSet = 1;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player1_set2_tieBreak_score_input, 'change', (e) => {
			 if (this.state.player1Set2TieBreakScore !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [set3Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, false, false, true, true);
			 }
			 this.state.player1Set2TieBreakScore = e.target.value;
			 this.state.currentSet = 2;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player2_set2_tieBreak_score_input, 'change', (e) => {
			 if (this.state.player2Set2TieBreakScore !== e.target.value) {
				 // Hiding next sets if current set score is changed.
				 let setArr = [set3Container, tieBreakSet3Container];
				 this.hideContainersAndClearValues(setArr);
				 this.clearSetContainerValues(false, false, false, true, true);
			 }
			 this.state.player2Set2TieBreakScore = e.target.value;
			 this.state.currentSet = 2;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player1_set3_tieBreak_score_input, 'change', (e) => {
			 this.state.player1Set3TieBreakScore = e.target.value;
			 this.state.currentSet = 3;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
		 EventHandler.on(player2_set3_tieBreak_score_input, 'change', (e) => {
			 this.state.player2Set3TieBreakScore = e.target.value;
			 this.state.currentSet = 3;
			 this._addNewBtn.classList.remove('u-hidden');
			 this._showNextBtn.classList.add('u-hidden');
		 });
 
 
		 EventHandler.on(this._addNewBtn, 'click', (e) => {
			 if (this.state.currentSet == 1) {
				 this.matchSetCalculator(Number(this.state.player1Set1Score), Number(this.state.player2Set1Score), Number(this.state.player1Set1TieBreakScore), Number(this.state.player2Set1TieBreakScore), this.state.acceptableSet1Scores, this.state.acceptableSet1ScoresCondition1, this.state.InputTieBreakSet1Scores, this.state.acceptableTieBreakScoreS1C1, this.state.acceptableTieBreakScoreS1C2, this.state.Set2Enabled, tieBreakSet1Container, this.state.currentSet, set2Container, player1_set1_score_input, player2_set1_score_input, player1_set1_tieBreak_score_input, player2_set1_tieBreak_score_input);
			 } else if (this.state.currentSet == 2) {
				 this.matchSetCalculator(Number(this.state.player1Set2Score), Number(this.state.player2Set2Score), Number(this.state.player1Set2TieBreakScore), Number(this.state.player2Set2TieBreakScore), this.state.acceptableSet2Scores, this.state.acceptableSet2ScoresCondition1, this.state.InputTieBreakSet2Scores, this.state.acceptableTieBreakScoreS2C1, this.state.acceptableTieBreakScoreS2C2, this.state.Set3Enabled, tieBreakSet2Container, this.state.currentSet, set3Container, player1_set2_score_input, player2_set2_score_input, player1_set2_tieBreak_score_input, player2_set2_tieBreak_score_input);
			 } else if (this.state.currentSet == 3) {
				 this.matchSetCalculator(Number(this.state.player1Set3Score), Number(this.state.player2Set3Score), Number(this.state.player1Set3TieBreakScore), Number(this.state.player2Set3TieBreakScore), this.state.acceptableSet3Scores, this.state.acceptableSet3ScoresCondition1, this.state.InputTieBreakSet3Scores, this.state.acceptableTieBreakScoreS3C1, this.state.acceptableTieBreakScoreS3C2, false, tieBreakSet3Container, this.state.currentSet, null, player1_set3_score_input, player2_set3_score_input, player1_set3_tieBreak_score_input, player2_set3_tieBreak_score_input);
			 }
		 });
 
 
		 continueCta.forEach((cta) => {
			 cta.addEventListener('click', () => {
				this._exitModal.hide();
			 });
		 });
 
		 exitCta && exitCta.forEach((cta) => {
			 cta.addEventListener('click', () => {
				 this.state.isSubmitted = true;
				 this.exitJourney()
			 });
		 });
 
		 nextSectionCtas && nextSectionCtas.forEach((cta) => {
			 cta.addEventListener('click', () => {
				 this.goToNextSection();
			 });
 
		 });
 
		 previousCtas && previousCtas.forEach((cta) => {
			 cta.addEventListener('click', () => {
				 // this.getPreviousPart();
				 this.goToPreviousSection();
			 });
		 });

		 
			
		 forms && forms.forEach((form) => {
			 form.addEventListener('change', (event) => {
				 this.checkForm(event);
			 });
		 });
 
 
		 // Edit Summary Page buttons
		 EventHandler.on(editPlayerBtn, 'click', () => {
			 if (this.state.matchFormat == 'Singles') {
				 [...Array(2)].forEach((_, i) => this.goToPreviousSection());
			 } else if (this.state.matchFormat == 'Doubles') {
				 [...Array(4)].forEach((_, i) => this.goToPreviousSection());
			 }
		 });
 
		 EventHandler.on(editMatchDetailsBtn, 'click', () => {
			 if (this.state.matchFormat == 'Singles') {
				 [...Array(3)].forEach((_, i) => this.goToPreviousSection());
			 } else if (this.state.matchFormat == 'Doubles') {
				 [...Array(5)].forEach((_, i) => this.goToPreviousSection());
			 }
		 });
 
		 EventHandler.on(editVenueBtn, 'click', () => {
			 if (this.state.matchFormat == 'Singles') {
				 [...Array(4)].forEach((_, i) => this.goToPreviousSection());
			 } else if (this.state.matchFormat == 'Doubles') {
				 [...Array(6)].forEach((_, i) => this.goToPreviousSection());
			 }
		 });
 
		 EventHandler.on(editDateBtn, 'click', () => {
			 if (this.state.matchFormat == 'Singles') {
				 [...Array(4)].forEach((_, i) => this.goToPreviousSection());
			 } else if (this.state.matchFormat == 'Doubles') {
				 [...Array(6)].forEach((_, i) => this.goToPreviousSection());
			 }
		 });
 
		 EventHandler.on(editScoreBtn, 'click', () => {
			 [...Array(1)].forEach((_, i) => this.goToPreviousSection());
		 });
	 }
 
	 disablePickerManualEntry() {
		 setTimeout(() => {
			 if (document.querySelector('.js-self-submission-date')) {
				 document.querySelector('.js-self-submission-date .duet-date__input').setAttribute('readonly', true);
				 document.querySelector('.js-self-submission-date .duet-date__input').addEventListener('click', function () {
					 document.querySelector(".js-self-submission-date").show();
				 });
			 }
		 }, 5000);
	 }
 
 
	 showLoader(value) {
		 if (value) {
			 this._loaderModal.show();
		 } else {
			 this._loaderModal.hide();
		 }
	 }
 
	 async recordPlayerProcess() {
		 const playerObj = Object.assign({}, {
			 "ContactId": this.state.myContactId
		 });
		 const data = await Request.post('/api/selfsubmission/recordprocess', playerObj).catch((e) => {
			 if (e.errorCode == '99') {
				 return false;
			 }
		 });
 
		 if (data) {
			 if (data.errors.errorCode == '00') {
				 return true;
			 }
		 }
	 }
 
	 async getDefaultVenues() {
		 const venues = await Request.get(`/api/selfsubmission/getRecentVenueByContactId?contactId=${this.state.myContactId}`)
			 .catch(e => {
				 if (e?.errors?.errorCode == '99') {
					 return false;
				 }
			 });
 
		 if (venues?.errors?.errorcode == '00') {
			 this.state.favVenues = this.selectRecentVenues(venues.response);
 
			 // Generate radio list for recent singles opponent
			 if (this.state.favVenues && this.state.favVenues.length > 0) {
				 this.state.recentVenuesListTemplate = this.generateRecentVenuesRadioList(this.state.favVenues);
				 return true;
			 } else {
				 this.state.recentVenuesListTemplate = null;
			 }
		 }
	 }
 
	 selectRecentVenues(venues) {
		 const venueArr = [];
		 let affVenuesCount = 0, recentVenueCount = 0;
		 for (let index = 0; index < 5; index++) {
			 if (venues.affiliatedVenues[affVenuesCount] != null) {
				 venueArr.push(venues.affiliatedVenues[affVenuesCount]);
				 affVenuesCount = affVenuesCount + 1;
			 } else if (venues.recentVenues[recentVenueCount] != null) {
				 venueArr.push(venues.recentVenues[recentVenueCount]);
				 recentVenueCount = recentVenueCount + 1;
			 }
		 }
		 return venueArr;
	 }
 
	 generateRecentVenuesRadioList(favVenues) {
		 const wrapperDiv = document.createElement('div');
		 if (favVenues && favVenues.length > 0) {
			 this.createHiddenVenueElementOnScreen(this.state.favVenues);
			 favVenues.forEach((el, i) => {
				 let currentDiv = this.generateRecentVenuesRadioListItem(el, i);
				 wrapperDiv.append(currentDiv);
			 });
			 return wrapperDiv;
		 }
	 }
 
	 createHiddenVenueElementOnScreen(favVenues) {
		 // hidden attr for fav venues
		 const hiddenDivForFavVenues = document.createElement('input');
		 hiddenDivForFavVenues.setAttribute('id', 'hidden-id-fav-Venues');
		 hiddenDivForFavVenues.setAttribute('type', 'hidden');
		 let hiddenFavVenues = '';
		 favVenues.forEach((el, i) => {
			 hiddenFavVenues = hiddenFavVenues.concat(el.id + ',');
		 });
		 hiddenDivForFavVenues.setAttribute('data-favVenueId', hiddenFavVenues);
		 document.body.appendChild(hiddenDivForFavVenues);
	 }
 
	 generateRecentVenuesRadioListItem(el, i) {
		 let div1 = document.createElement('label');
		 div1.classList.add('lta-form-check', 'u-mb-1', 'u-hstack', 'u-justify-flex-start');
		 div1.style.cursor = 'pointer';
		 let input = document.createElement('input');
		 input.classList.add('lta-form-check-input');
		 input.setAttribute("type", "radio");
		 input.setAttribute("name", `recent-venue`);
		 input.setAttribute("id", `${el.id + '-' + i}`);
		 input.setAttribute("value", `${el.id}`);
		 div1.setAttribute("for", `${el.id + '-' + i}`);
		 let div2 = document.createElement('div');
		 div2.classList.add('lta-venue--template', 'u-ml-2');
		 div2.style.width = '100%';
		 let div3 = document.createElement('div');
		 div3.style.minHeight = '60px';
		 div3.classList.add('lta-location-card', 'u-mb-1');
		 let div4 = document.createElement('div');
		 div4.classList.add('lta-location-card--content', 'recent-player');
		 let div5 = document.createElement('div');
		 div5.classList.add('recent-player-container');
		 let paragraph = document.createElement('p');
		 paragraph.classList.add('u-h6');
		 paragraph.innerText = `${el.name}`;
		 document.createElement('br');
		 let h5 = document.createElement('h5');
		 h5.classList.add('u-body3');
		 h5.innerText = `${el.address.postalcode}`;
 
		 div1.append(input);
		 div1.appendChild(div2);
		 div2.appendChild(div3);
		 div3.appendChild(div4);
		 div4.appendChild(div5);
		 div5.appendChild(paragraph);
		 div5.appendChild(h5);
		 return div1;
	 }
 
	 async getDefaults() {
		 const data = await Request.get(`/api/selfsubmission/getDefaultParameters?contactid=${this.state.myContactId}`)
			 .catch(e => {
				 if (e?.errors?.errorCode == '99') {
					 return false;
				 }
			 });
 
		 if (data?.errors?.errorcode == '00') {
			 this.state.getDefaultParams = data.response.defaults;
			 this.state.sportPlayed = this.state.getDefaultParams.sport;
			 this.state.tennisBallColor = this.state.getDefaultParams.ballColor;
			 this.state.matchCategory = this.state.getDefaultParams.matchCategory;
			 this.state.firstTimeSubmission = this.state.getDefaultParams.firstTimeSubmission;
		 }
	 }
 
	 async getFavouritePlayers() {
		 const data = await Request.get(`/api/selfsubmission/getFavouriteAndRecentPlayersByContactId?ContactId=${this.state.myContactId}`)
			 .catch((e) => {
				 if (e?.errors?.errorCode == '99') {
					 return false;
				 }
			 });
 
		 if (data?.errors?.errorcode == '00') {
			 this.state.favPlayers = JSON.stringify(data.response.favouritesRecentlyPlayed);
 
			 // Generate radio list for recent singles opponent
			 if (data.response.favouritesRecentlyPlayed && data.response.favouritesRecentlyPlayed.length > 0) {
				 this.state.recentPlayerListTemplate = this.generateRecentPlayersRadioList(JSON.parse(this.state.favPlayers), 'SingleOpponent');
				 this.state.recentPartnerPlayerListTemplate = this.generateRecentPlayersRadioList(JSON.parse(this.state.favPlayers), 'DoublesPartner');
				 this.state.recentOpponent1PlayerListTemplate = this.generateRecentPlayersRadioList(JSON.parse(this.state.favPlayers), 'DoublesOpponent1');
				 this.state.recentOpponent2PlayerListTemplate = this.generateRecentPlayersRadioList(JSON.parse(this.state.favPlayers), 'DoublesOpponent2');
				 document.querySelector('.js-favourite-opponent2-player-list').append(this.state.recentOpponent2PlayerListTemplate);
			 } else {
				 this.state.recentPlayerListTemplate = null;
				 this.state.recentPartnerPlayerListTemplate = null;
				 this.state.recentOpponent1PlayerListTemplate = null;
				 this.state.recentOpponent2PlayerListTemplate = null;
			 }
		 }
	 }
 
	 createHiddenElementOnScreen(favPlayers) {
		 // hidden attr for fav players
		 const hiddenDivForFavPlayers = document.createElement('input');
		 hiddenDivForFavPlayers.setAttribute('id', 'hidden-id-fav-players');
		 hiddenDivForFavPlayers.setAttribute('type', 'hidden');
		 let hiddenFavPlayers = '';
		 favPlayers.forEach((el, i) => {
			 hiddenFavPlayers = hiddenFavPlayers.concat(el.id + ',');
		 });
		 hiddenDivForFavPlayers.setAttribute('data-favContactId', hiddenFavPlayers);
		 document.body.appendChild(hiddenDivForFavPlayers);
	 }
 
	 generateRecentPlayersRadioList(favPlayers, playerType) {
		 const wrapperDiv = document.createElement('div');
		 if (favPlayers && favPlayers.length > 0) {
			 this.createHiddenElementOnScreen(JSON.parse(this.state.favPlayers));
			 favPlayers.forEach((el, i) => {
				 let currentDiv = this.generateRecentPlayersRadioListItem(el, i, playerType);
				 wrapperDiv.append(currentDiv);
			 });
			 return wrapperDiv;
		 }
	 }
 
	 generateRecentPlayersRadioListItem(el, i, playerType) {
		 let div1 = document.createElement('label');
		 div1.classList.add('lta-form-check', 'u-mb-1', 'u-hstack');
		 div1.style.cursor = 'pointer';
		 let input = document.createElement('input');
		 input.classList.add('lta-form-check-input');
		 input.setAttribute("type", "radio");
		 input.setAttribute("name", `recent-player`);
		 input.setAttribute("id", `${el.id + '-' + i + '-' + playerType}`);
		 input.setAttribute("value", `${el.id}`);
		 div1.setAttribute("for", `${el.id + '-' + i + '-' + playerType}`);
		 let div2 = document.createElement('div');
		 div2.classList.add('lta-venue--template', 'u-ml-2');
		 div2.style.width = '100%';
		 let div3 = document.createElement('div');
		 div3.classList.add('lta-location-card', 'u-mb-1');
		 div3.style.minHeight = '60px';
		 let div4 = document.createElement('div');
		 div4.classList.add('lta-location-card--content', 'recent-player');
		 let div5 = document.createElement('div');
		 div5.classList.add('recent-player-container');
		 let paragraph = document.createElement('p');
		 paragraph.classList.add('u-h6');
		 paragraph.innerText = `${el.firstname}` + ' ' + `${el.lastname}`;
		 document.createElement('br');
		 let h5 = document.createElement('h5');
		 h5.classList.add('u-body3');
		 let h5_1 = document.createElement('h5');
		 h5_1.classList.add('u-body3');
		 h5_1.innerText = `${el.gender}`;
 
		 div1.append(input);
		 div1.appendChild(div2);
		 div2.appendChild(div3);
		 div3.appendChild(div4);
		 div4.appendChild(div5);
		 div5.appendChild(paragraph);
		 if (el.gender != null) {
			 div5.appendChild(h5_1);
		 }
		 return div1;
	 }
 
	 async saveDefaults() {
		 let defaultData;
		 defaultData = Object.assign({}, {
			 "contactId": this.state.myContactId,
			 "venue": this.state.selectedVenue[0].id,
			 "sport": this.state.sportPlayed,
			 ...(this.state.sportPlayed == 'Tennis') ? { "ballColor": this.state.tennisBallColor } : null,
			 "matchCategory": this.state.matchCategory
		 });
 
		 const defaults = await Request.post('/api/selfsubmission/updateDefaultParam', defaultData).catch((e) => {
			 if (e.errors.errorCode == '99') {
				 return false;
			 }
		 });
 
		 if (defaults.errors.errorcode == '00') {
			 this._defaultsModal.hide();
		 }
		 return;
	 };
 
	 async getDeduplicationData() {
		 let finalData;
		 if (this.state.matchFormat == 'Singles') {
			 if (!this.state.selectedPlayer[0].id) {
				 return;
			 } else {
				 var team1Arr = [{ "contactId": this.state.myContactId }];
				 var team2Arr = [{ "contactId": this.state.selectedPlayer[0].id }];
				 finalData = Object.assign({}, {
					 "matchType": this.state.matchFormat,
					 "date": this.state.dateValue,
					 "players": {
						 "team1": team1Arr,
						 "team2": team2Arr
					 }
				 });
			 }
		 } else if (this.state.matchFormat == 'Doubles') {
			 if (!this.state.selectedPartner[0].id || !this.state.selectedOpponent1[0].id || !this.state.selectedOpponent2[0].id) {
				 return;
			 } else {
				 var team1Arr = [{ "contactId": this.state.myContactId }, { "contactId": this.state.selectedPartner[0].id }];
				 var team2Arr = [{ "contactId": this.state.selectedOpponent1[0].id }, { "contactId": this.state.selectedOpponent2[0].id }];
				 finalData = Object.assign({}, {
					 "matchType": this.state.matchFormat,
					 "date": this.state.dateValue,
					 "players": {
						 "team1": team1Arr,
						 "team2": team2Arr
					 }
				 });
			 }
		 }
 
		 const dedupData = await Request.post('/api/selfsubmission/matchdeduplicationcheck', finalData).catch(e => {
			 if (e.errors.errorCode == '99' || e.errors.errorCode == '01') {
				 return false;
			 }
		 });
 
		 if (dedupData.errors.errorcode == '00') {
			 const dedupInfo = document.getElementById('self-submission-deduplication-check')?.querySelector('.lta-venue--template');
			 const children = dedupData.matchDetails.matchDuplicates.map(item => {
				 return this.generateCarouselChildren({ item });
			 }).join('');
			 const slides = this.genereateCarousel({ children });
			 dedupInfo.innerHTML = slides;
			 this._dedupModal.show();
			 const carouselsv2 = SelectorEngine.find('.js-lta-carouselv2', dedupInfo);
			 for (const carousel of [...carouselsv2]) {
				 CarouselV2.getInstance() || new CarouselV2(carousel, {});
			 }
		 }
	 };
 
	 genereateCarousel({ classes = '', useCSSGrid = false, children }) {
		 const classNames = classnames(
			 'lta-carouselv2',
			 'js-lta-carouselv2',
			 classes
		 );
		 return `
			 <div class="${classNames}"data-slides-per-view-xl="1" data-slides-per-view-md="1" data-slides-per-view-sm="1">
				 <div class="swiper">
					 <div class=${classnames("swiper-wrapper", useCSSGrid ? 'l-lta-grid' : '')}>
						 ${children}
					 </div>
					 <div class="lta-carouselv2__controls">
						 <button class="lta-carouselv2__prev u-mr-2 swiper-button-disabled" disabled="" data-ol-has-click-handler="">
							 <svg class="lta-icon js-lta-text-input--btn-icon" width="2rem" height="2rem" fill="currentColor" alt="arrow-left-circle" aria-hidden="true">
								 <use xlink:href="/static/images/icons/lta-icons.svg#arrow-left-circle"></use>
							 </svg>
						 </button>
						 <div class="lta-carouselv2__pagination u-hstack u-gap-1 swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal" data-ol-has-click-handler=""></div>
						 <button class="lta-carouselv2__next u-ml-2" data-ol-has-click-handler="">
							 <svg class="lta-icon js-lta-text-input--btn-icon" width="2rem" height="2rem" fill="currentColor" alt="arrow-right-circle" aria-hidden="true">
								 <use xlink:href="/static/images/icons/lta-icons.svg#arrow-right-circle"></use>
							 </svg>
						 </button>
					 </div>
			 </div>
		 `;
	 }
 
	 generateCarouselChildren({ classes, item }) {
		 const { date, players, score, status, submitterName } = item;
		 const classNames = classnames(
			 'swiper-slide',
			 classes
		 );
		 return `<div class="${classNames}">
			 <div class="lta-location-card u-mb-1">
				 <div class="lta-location-card--content dedup-match-score">
					 <div class="dedup-match-details">
						 <p class="u-h6 ">Date of match</p>
						 <h5 class="u-body3 ">${date}</h5>
					 </div>
 
					 <div class="dedup-match-details u-mt-3">
						 <p class="u-h6 ">Players</p>
						 <h5 class="u-body3 ">${players.join(', ')}</h5>
					 </div>
 
					 <div class="dedup-match-details u-mt-3">
						 <p class="u-h6 ">Match score</p>
						 <h5 class="u-body3 ">${score}</h5>
					 </div>
 
					 <div class="dedup-match-details u-mt-3">
						 <p class="u-h6 ">Status</p>
						 <h5 class="u-body3 ">${status}</h5>
					 </div>
 
					 <div class="dedup-match-details u-mt-3">
						 <p class="u-h6 ">Submitted by</p>
						 <h5 class="u-body3 ">${submitterName}</h5>
					 </div>
				 </div>
			 </div>
		 </div>`;
	 }
 
	 async submitScore() {
		 let gender = this.validateGender();
		 const scoreData = Object.assign({}, {
			 "contactId": this.state.myContactId,
			 "sport": this.state.sportPlayed,
			 "matchType": this.state.matchFormat,
			 "matchCategory": this.state.matchCategory,
			 "date": this.state.dateValue,
			 "scoreFormat": this.state.selectedScoreFormatName,
			 "scores": {
				 "score": [
					 {
						 "set": "1",
						 "team1": this.state.player1Set1Score,
						 "team2": this.state.player2Set1Score
					 },
					 ...(this.state.player1Set2Score && this.state.player2Set2Score) ?
						 [{
							 "set": "2",
							 "team1": this.state.player1Set2Score,
							 "team2": this.state.player2Set2Score
						 }] : [],
					 ...(this.state.player1Set3Score && this.state.player2Set3Score) ?
						 [{
							 "set": "3",
							 "team1": this.state.player1Set3Score,
							 "team2": this.state.player2Set3Score
						 }] : [],
				 ],
				 "tiebreak": [
					 ...(this.state.player1Set1TieBreakScore || this.state.player2Set1TieBreakScore) ?
						 [{
							 "set": "1",
							 "team1": this.state.player1Set1TieBreakScore,
							 "team2": this.state.player2Set1TieBreakScore
						 }] : [],
 
					 ...(this.state.player1Set2TieBreakScore || this.state.player2Set2TieBreakScore) ?
						 [{
							 "set": "2",
							 "team1": this.state.player1Set2TieBreakScore,
							 "team2": this.state.player2Set2TieBreakScore
						 }] : [],
 
					 ...(this.state.player1Set3TieBreakScore || this.state.player2Set3TieBreakScore) ?
						 [{
							 "set": "3",
							 "team1": this.state.player1Set3TieBreakScore,
							 "team2": this.state.player2Set3TieBreakScore
						 }] : []
				 ]
			 },
			 "players": {
				 "team1": [
					 {
						 "contactId": this.state.myContactId
					 },
 
					 ...(this.state.matchFormat == 'Doubles' && Boolean(this.state.selectedPartner[0].id)) ?
						 [{
							 "contactId": this.state.selectedPartner[0].id
						 }] : [],
 
					 ...(this.state.matchFormat == 'Doubles' && !Boolean(this.state.selectedPartner[0].id)) ?
						 [{
							 "firstName": this.state.selectedPartner[0].firstname,
							 "lastName": this.state.selectedPartner[0].lastname,
							 "referralCode": `${this.state.partnerRefferalCode}-${this.state.selectedPartner[0].firstname}-Partner`
						 }] : [],
				 ],
 
				 "team2": [
 
					 ...(this.state.matchFormat == 'Singles' && Boolean(this.state.selectedPlayer[0].id)) ?
						 [{
							 "contactId": this.state.selectedPlayer[0].id
						 }] : [],
					 ...(this.state.matchFormat == 'Singles' && !Boolean(this.state.selectedPlayer[0].id)) ?
						 [{
							 "firstName": this.state.selectedPlayer[0].firstname,
							 "lastName": this.state.selectedPlayer[0].lastname,
							 "referralCode": `${this.state.singlesReferralCode}-${this.state.selectedPlayer[0].firstname}-Opponent`
						 }] : [],
 
					 ...(this.state.matchFormat == 'Doubles' && Boolean(this.state.selectedOpponent1[0].id)) ?
						 [{
							 "contactId": this.state.selectedOpponent1[0].id
						 }] : [],
					 ...(this.state.matchFormat == 'Doubles' && !Boolean(this.state.selectedOpponent1[0].id)) ?
						 [{
							 "firstName": this.state.selectedOpponent1[0].firstname,
							 "lastName": this.state.selectedOpponent1[0].lastname,
							 "referralCode": `${this.state.opponent1ReferralCode}-${this.state.selectedOpponent1[0].firstname}-Opponent1`
						 }] : [],
 
					 ...(this.state.matchFormat == 'Doubles' && Boolean(this.state.selectedOpponent2[0].id)) ?
						 [{
							 "contactId": this.state.selectedOpponent2[0].id
						 }] : [],
					 ...(this.state.matchFormat == 'Doubles' && !Boolean(this.state.selectedOpponent2[0].id)) ?
						 [{
							 "firstName": this.state.selectedOpponent2[0].firstname,
							 "lastName": this.state.selectedOpponent2[0].lastname,
							 "referralCode": `${this.state.opponent2ReferralCode}-${this.state.selectedOpponent2[0].firstname}-Opponent2`
						 }] : [],
				 ]
			 },
			 "winner": this.state.matchWinner,
			 "venue": this.state.selectedVenue[0] && this.state.selectedVenue[0].id ? this.state.selectedVenue[0].id : '',
			 "gender": gender,
			 "ballColour": this.state.tennisBallColor,
			 "firstTimeSubmission": true,
			 "WTN": false
		 }
		 );
		 const data = await Request.post('/api/selfsubmission/submitresult', scoreData)
			 .catch((e) => {
				 if (e?.errors?.errorcode == '99') {
					 return false;
				 }
			 });
 
		 if (data.errors.errorcode == '00') {
			 this._isRecommended = true;
			 this.state.isSubmitted = true;
			 this._modal.hide();
			 this._successModal.show();
			 if (this.state.playerFirstName && this.state.playerLastName || this.state.partnerFirstName && this.state.partnerLastName || this.state.opponent1FirstName && this.state.opponent1LastName ||
				 this.state.opponent2FirstName && this.state.opponent2LastName) {
				 document.querySelector('.invite-players').classList.remove('u-hidden');
			 } else {
				 document.querySelector('.invite-players').classList.add('u-hidden');
			 }
			 if (this.state.getDefaultParams.firstTimeSubmission == true && this.state.sportPlayed !== "Padel") {
				 let defaultsInfo = document.getElementById('js-defaults-modal').querySelector('.defaults-popup-container');
 
				 defaultsInfo.querySelector('#defaultSport').checked = true;
				 defaultsInfo.querySelector('#defaultSport').disabled = true;
				 defaultsInfo.querySelector('.default-sport-value').innerText = this.state.sportPlayed || this.state.getDefaultParams.sport;
 
				 if ((this.state.sportPlayed || this.state.getDefaultParams.sport) == 'Tennis') {
					 defaultsInfo.querySelector('#defaultTennisBallColor').checked = true;
					 defaultsInfo.querySelector('#defaultTennisBallColor').disabled = true;
					 defaultsInfo.querySelector('.default-color-value').innerText = this.state.tennisBallColor || this.state.getDefaultParams.ballColor;
				 } else if ((this.state.sportPlayed || this.state.getDefaultParams.sport) == 'Padel') {
					 defaultsInfo.querySelector('.default-color-value').innerText = '';
					 document.getElementById('save-match-defaults').children[2].classList.add('u-hidden');
				 }
 
				 defaultsInfo.querySelector('#defaultMatchCategory').checked = true;
				 defaultsInfo.querySelector('#defaultMatchCategory').disabled = true;
				 defaultsInfo.querySelector('.default-category-value').innerText = this.state.matchCategory || this.state.getDefaultParams.matchCategory;
 
				 this._defaultsModal.show();
 
			 } else {
				 this._defaultsModal.hide();
			 }
		 } else {
			 alert(data.errors.errormessage);
		 }
	 }
 
	 validateGender() {
		 if (this.state.matchFormat == 'Singles') {
			 if (this.state.selectedPlayer[0].gender == this.state.myGender) {
				 return this.state.myGender;
			 } else {
				 return "Mixed";
			 }
		 } else if (this.state.matchFormat == 'Doubles') {
			 if (this.state.selectedOpponent1[0].gender === this.state.selectedOpponent2[0].gender === this.state.myGender === this.state.selectedPartner[0].gender) {
				 return this.state.myGender;
			 } else {
				 return "Mixed";
			 }
		 }
	 }
 
	 async updateSinglesReferFriend() {
		 await Request.post(`/api/selfsubmission/UpdateReferFriend?contactId=${this.state.myContactId}&code=${this.state.singlesReferralCode}-${this.state.selectedPlayer[0].firstname}-Opponent`).catch((e) => {
			 if (e.errorCode == '99') {
				 return false;
			 }
		 });
	 }
 
	 async updatePartnerReferFriend() {
		 await Request.post(`/api/selfsubmission/UpdateReferFriend?contactId=${this.state.myContactId}&code=${this.state.partnerRefferalCode}-${this.state.selectedPartner[0].firstname}-Partner`).catch((e) => {
			 if (e.errorCode == '99') {
				 return false;
			 }
		 });
	 }
 
	 async updateOpponent1ReferFriend() {
		 await Request.post(`/api/selfsubmission/UpdateReferFriend?contactId=${this.state.myContactId}&code=${this.state.opponent1ReferralCode}-${this.state.selectedOpponent1[0].firstname}-Opponent1`).catch((e) => {
			 if (e.errorCode == '99') {
				 return false;
			 }
		 });
	 }
 
	 async updateOpponent2ReferFriend() {
		 await Request.post(`/api/selfsubmission/UpdateReferFriend?contactId=${this.state.myContactId}&code=${this.state.opponent2ReferralCode}-${this.state.selectedOpponent2[0].firstname}-Opponent2`).catch((e) => {
			 if (e.errorCode == '99') {
				 return false;
			 }
		 });
	 }
 
	 showScoreFormatSelectedSection(selectedScoreFormat) {
		 switch (selectedScoreFormat) {
			 case "rule1":
				 this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule1.acceptableSet1Scores;
				 this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule1.acceptableSet1ScoresCondition1;
				 this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule1.InputTieBreakSet1Scores;
				 this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS1C1;
				 this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS1C2;
				 this.state.Set2Enabled = this.state.scoreFormatRules.rule1.Set2Enabled;
 
				 this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule1.acceptableSet2Scores;
				 this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule1.InputTieBreakSet2Scores;
				 this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS2C1;
				 this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS2C2;
				 this.state.Set3Enabled = this.state.scoreFormatRules.rule1.Set3Enabled;
 
				 this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule1.acceptableSet3Scores;
				 this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule1.acceptableSet3ScoresCondition1;
				 this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule1.InputTieBreakSet3Scores;
				 this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS3C1;
				 this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS3C2;
				 break;
 
			 case "rule2":
				 this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule2.acceptableSet1Scores;
				 this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule2.acceptableSet1ScoresCondition1;
				 this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule2.InputTieBreakSet1Scores;
				 this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS1C1;
				 this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS1C2;
				 this.state.Set2Enabled = this.state.scoreFormatRules.rule2.Set2Enabled;
 
				 this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule2.acceptableSet2Scores;
				 this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule2.InputTieBreakSet2Scores;
				 this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS2C1;
				 this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS2C2;
				 this.state.Set3Enabled = this.state.scoreFormatRules.rule2.Set3Enabled;
 
				 this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule2.acceptableSet3Scores;
				 this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule2.acceptableSet3ScoresCondition1;
				 this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule2.InputTieBreakSet3Scores;
				 this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS3C1;
				 this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS3C2;
				 break;
 
			 case "rule3":
				 this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule3.acceptableSet1Scores;
				 this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule3.acceptableSet1ScoresCondition1;
				 this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule3.InputTieBreakSet1Scores;
				 this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS1C1;
				 this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS1C2;
				 this.state.Set2Enabled = this.state.scoreFormatRules.rule3.Set2Enabled;
 
				 this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule3.acceptableSet2Scores;
				 this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule3.InputTieBreakSet2Scores;
				 this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS2C1;
				 this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS2C2;
				 this.state.Set3Enabled = this.state.scoreFormatRules.rule3.Set3Enabled;
 
				 this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule3.acceptableSet3Scores;
				 this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule3.acceptableSet3ScoresCondition1;
				 this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule3.InputTieBreakSet3Scores;
				 this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS3C1;
				 this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS3C2;
				 break;
 
			 case "rule4":
				 this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule4.acceptableSet1Scores;
				 this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule4.acceptableSet1ScoresCondition1;
				 this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule4.InputTieBreakSet1Scores;
				 this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS1C1;
				 this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS1C2;
				 this.state.Set2Enabled = this.state.scoreFormatRules.rule4.Set2Enabled;
 
				 this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule4.acceptableSet2Scores;
				 this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule4.InputTieBreakSet2Scores;
				 this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS2C1;
				 this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS2C2;
				 this.state.Set3Enabled = this.state.scoreFormatRules.rule4.Set3Enabled;
 
				 this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule4.acceptableSet3Scores;
				 this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule4.acceptableSet3ScoresCondition1;
				 this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule4.InputTieBreakSet3Scores;
				 this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS3C1;
				 this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS3C2;
				 break;
 
			 case "rule5":
				 this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule5.acceptableSet1Scores;
				 this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule5.acceptableSet1ScoresCondition1;
				 this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule5.InputTieBreakSet1Scores;
				 this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS1C1;
				 this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS1C2;
				 this.state.Set2Enabled = this.state.scoreFormatRules.rule5.Set2Enabled;
 
				 this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule5.acceptableSet2Scores;
				 this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule5.InputTieBreakSet2Scores;
				 this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS2C1;
				 this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS2C2;
				 this.state.Set3Enabled = this.state.scoreFormatRules.rule5.Set3Enabled;
 
				 this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule5.acceptableSet3Scores;
				 this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule5.acceptableSet3ScoresCondition1;
				 this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule5.InputTieBreakSet3Scores;
				 this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS3C1;
				 this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS3C2;
				 break;
 
			 case "rule6":
				 this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule6.acceptableSet1Scores;
				 this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule6.acceptableSet1ScoresCondition1;
				 this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule6.InputTieBreakSet1Scores;
				 this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS1C1;
				 this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS1C2;
				 this.state.Set2Enabled = this.state.scoreFormatRules.rule6.Set2Enabled;
 
				 this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule6.acceptableSet2Scores;
				 this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule6.InputTieBreakSet2Scores;
				 this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS2C1;
				 this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS2C2;
				 this.state.Set3Enabled = this.state.scoreFormatRules.rule6.Set3Enabled;
 
				 this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule6.acceptableSet3Scores;
				 this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule6.acceptableSet3ScoresCondition1;
				 this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule6.InputTieBreakSet3Scores;
				 this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS3C1;
				 this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS3C2;
				 break;
		 }
	 }
 
	 clearSetContainerValues(set1TiebreakScore, set2Score, set2TiebreakScore, set3Score, set3TiebreakScore) {
		 if (set1TiebreakScore) {
			 this.state.set1TiebreakScore = '';
			 this.state.player1Set1TieBreakScore = '';
			 this.state.player2Set1TieBreakScore = '';
		 }
		 if (set2Score) {
			 this.state.set2Score = '';
			 this.state.player1Set2Score = '';
			 this.state.player2Set2Score = '';
		 }
		 if (set2TiebreakScore) {
			 this.state.set2TiebreakScore = '';
			 this.state.player1Set2TieBreakScore = '';
			 this.state.player2Set2TieBreakScore = '';
		 }
		 if (set3Score) {
			 this.state.set3Score = '';
			 this.state.player1Set3Score = '';
			 this.state.player2Set3Score = '';
		 }
		 if (set3TiebreakScore) {
			 this.state.set3TiebreakScore = '';
			 this.state.player1Set3TieBreakScore = '';
			 this.state.player2Set3TieBreakScore = '';
		 }
	 }
 
	 hideContainersAndClearValues(setArr) {
		 setArr && setArr.map(i => {
			 i && i.classList.add('u-hidden');
			 i.querySelectorAll("input")[0].value = '';
			 i.querySelectorAll("input")[1].value = '';
		 });
	 }
 
	 matchSetCalculator(player1SetScore, player2SetScore, player1SetTieBreakScore, player2SetTieBreakScore, acceptableSetScores, acceptableSetScoresC1, InputTieBreakSetScores, acceptableTieBreakScoreC1, acceptableTieBreakScoreC2, nextSetEnabled, tieBreakSetContainer, currentSet, setContainer, player1_set_score_input, player2_set_score_input, player1_set_tieBreak_score_input, player2_set_tieBreak_score_input) {
 
		 if (!this.validateScores(player1_set_score_input, player2_set_score_input)) {
			 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
			 document.querySelector('.self-submission-score-error-message').innerText = 'Validate Scores error';
			 document.querySelector('.self-submission-score-error-message').scrollIntoView();
			 return;
		 } else {
			 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
			 document.querySelector('.self-submission-score-error-message').innerText = '';
		 }
 
		 let setScore = player1SetScore + '-' + player2SetScore;
		 this.saveSetScore(setScore, currentSet);
 
		 if ((acceptableSetScores !== null && acceptableSetScores.includes(setScore)) || (acceptableSetScoresC1 !== null && !acceptableSetScores.includes(setScore))) {
			 //Check for additional acceptable set score condition if exist
			 if (acceptableSetScoresC1 !== null && !acceptableSetScores.includes(setScore)) {
				 if (!this.calculateCustomPlayerScoreGreaterThanValueAndDifference(acceptableSetScoresC1, player1SetScore, player2SetScore)) {
					 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
					 document.querySelector('.self-submission-score-error-message').innerText = 'This score doesnt look right – please try again';
					 document.querySelector('.self-submission-score-error-message').scrollIntoView();
					 return;
				 } else {
					 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
				 }
			 }
			 if (InputTieBreakSetScores !== null) {
				 // Check if Tie break condition is applicable
				 if (InputTieBreakSetScores.includes(setScore)) {
 
					 // Check if tie break set 1 is already visible
					 if (!tieBreakSetContainer.classList.contains('u-hidden')) {
						 if (!this.validateScores(player1_set_tieBreak_score_input, player2_set_tieBreak_score_input)) {
							 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
							 document.querySelector('.self-submission-score-error-message').innerText = 'Validate tie break scores error';
							 document.querySelector('.self-submission-score-error-message').scrollIntoView();
							 return;
						 } else {
							 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
							 document.querySelector('.self-submission-score-error-message').innerText = '';
						 }
						 // Check for invalid tie break score
						 if (!this.validateWithCurrentSetScores(player1SetScore, player2SetScore, player1SetTieBreakScore, player2SetTieBreakScore)) {
							 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
							 document.querySelector('.self-submission-score-error-message').innerText = 'Invalid tie break scores';
							 document.querySelector('.self-submission-score-error-message').scrollIntoView();
							 return;
						 } else {
							 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
							 document.querySelector('.self-submission-score-error-message').innerText = '';
						 }
						 let currentSetTieBreakScore = player1SetTieBreakScore + '-' + player2SetTieBreakScore;
						 this.saveTieBreakScore(currentSetTieBreakScore, currentSet);
						 if (this.customAcceptableTieBreakConditions(acceptableTieBreakScoreC1, acceptableTieBreakScoreC2, player1SetTieBreakScore, player2SetTieBreakScore)) {
							 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
							 document.querySelector('.self-submission-score-error-message').innerText = '';
							 this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
							 this.decideNextStep(currentSet, setContainer, nextSetEnabled);
						 } else {
							 // Check if scores are not as per acceptable formats
							 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
							 document.querySelector('.self-submission-score-error-message').scrollIntoView();
							 document.querySelector('.self-submission-score-error-message').innerText = 'Invalid tie break scores';
						 }
					 } else {
						 // Check if current tie break set is hidden
						 tieBreakSetContainer.classList.remove('u-hidden');
						 tieBreakSetContainer.scrollIntoView();
					 }
 
				 } else {
					 this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
					 this.decideNextStep(currentSet, setContainer, nextSetEnabled);
				 }
			 } else {
				 // Declare Match Winner for first to 10 points & Different Format.
				 this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
				 this.decideNextStep(currentSet, setContainer, nextSetEnabled);
			 }
		 } else {
			 // For any score format
			 document.querySelector('.self-submission-score-error-message').classList.add('u-hidden');
			 document.querySelector('.self-submission-score-error-message').innerText = '';
			 if (acceptableSetScores == 'any') {
				 if (player1SetScore > player2SetScore) {
					 this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
					 this.decideNextStep(currentSet, setContainer, nextSetEnabled);
				 } else if (player2SetScore > player1SetScore) {
					 this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
					 this.decideNextStep(currentSet, setContainer, nextSetEnabled);
				 } else if (player2SetScore == player1SetScore) {
					 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
					 document.querySelector('.self-submission-score-error-message').innerText = 'This score doesnt look right – please try again';
					 document.querySelector('.self-submission-score-error-message').scrollIntoView();
				 }
			 } else {
				 // Check if scores are not as per acceptable formats
				 document.querySelector('.self-submission-score-error-message').classList.remove('u-hidden');
				 document.querySelector('.self-submission-score-error-message').innerText = 'This score doesnt look right – please try again';
				 document.querySelector('.self-submission-score-error-message').scrollIntoView();
			 }
 
		 }
	 }
 
	 saveSetScore(setScore, currentSet) {
		 switch (currentSet.toString()) {
			 case "1":
				 this.state.set1Score = setScore;
				 break;
			 case "2":
				 this.state.set2Score = setScore;
				 break;
			 case "3":
				 this.state.set3Score = setScore;
				 break;
		 }
	 }
 
	 saveTieBreakScore(currentSetTieBreakScore, currentSet) {
		 switch (currentSet.toString()) {
			 case "1":
				 this.state.set1TiebreakScore = currentSetTieBreakScore;
				 break;
			 case "2":
				 this.state.set2TiebreakScore = currentSetTieBreakScore;
				 break;
			 case "3":
				 this.state.set3TiebreakScore = currentSetTieBreakScore;
				 break;
		 }
	 }
 
 
	 validateWithCurrentSetScores(player1SetScore, player2SetScore, player1SetTieBreakScore, player2SetTieBreakScore) {
		 if ((player1SetScore > player2SetScore) && (player1SetTieBreakScore > player2SetTieBreakScore)) {
			 return true;
		 } else if ((player2SetScore > player1SetScore) && (player2SetTieBreakScore > player1SetTieBreakScore)) {
			 return true;
		 }
		 return false;
	 }
 
	 calculateCustomPlayerScoreGreaterThanValueAndDifference(acceptableSetScoresCondition, player1SetScore, player2SetScore) {
		 let player1Limit, player2Limit, difference;
		 if (acceptableSetScoresCondition) {
			 player1Limit = Number(acceptableSetScoresCondition[0].split('-')[1]);
			 player2Limit = Number(acceptableSetScoresCondition[0].split('-')[1]);
			 difference = Number(acceptableSetScoresCondition[2].split('-')[1]);
			 if (player1SetScore >= player1Limit && player2SetScore >= player2Limit) {
				 if (player1SetScore > player2SetScore && player1SetScore - player2SetScore == difference) {
					 return true;
				 }
				 if (player2SetScore > player1SetScore && player2SetScore - player1SetScore == difference) {
					 return true;
				 }
			 }
		 }
		 return false;
	 }
 
 
	 customAcceptableTieBreakConditions(acceptableTieBreakScoreC1, acceptableTieBreakScoreC2, player1SetTieBreakScore, player2SetTieBreakScore) {
		 if (acceptableTieBreakScoreC1.includes(player1SetTieBreakScore + '-' + player2SetTieBreakScore)) {
			 return true;
		 }
		 return this.calculateCustomPlayerScoreGreaterThanValueAndDifference(acceptableTieBreakScoreC2, player1SetTieBreakScore, player2SetTieBreakScore);
	 }
 
	 decideNextStep(currentSet, setContainer, nextSetEnabled) {
		 switch (currentSet.toString()) {
			 case "1":
				 if (nextSetEnabled) {
					 setContainer.classList.remove('u-hidden');
					 this.state.currentSet = currentSet + 1;
					 setContainer.scrollIntoView();
					 this.hideNextButton(this._showNextBtn);
				 } else {
					 this.showNextButton(this._showNextBtn, this._addNewBtn);
				 }
				 break;
			 case "2":
				 if (this.state.set1Winner == this.state.set2Winner) {
					 this.showNextButton(this._showNextBtn, this._addNewBtn);
				 } else if (nextSetEnabled) {
					 setContainer.classList.remove('u-hidden');
					 setContainer.scrollIntoView();
					 this.state.currentSet = currentSet + 1;
					 this.hideNextButton(this._showNextBtn);
				 } else {
					 this.showNextButton(this._showNextBtn, this._addNewBtn);
				 }
				 break;
			 case "3":
				 this.showNextButton(this._showNextBtn, this._addNewBtn);
				 break;
		 }
	 }
 
	 showNextButton(showNextBtn, addNewBtn) {
		 addNewBtn.classList.add('u-hidden');
		 showNextBtn.classList.remove('u-hidden');
		 showNextBtn.scrollIntoView();
	 }
 
	 hideNextButton(showNextBtn) {
		 !showNextBtn.classList.contains('u-hidden') && showNextBtn.classList.add('u-hidden');
	 }
 
	 decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled) {
		 let setWinner;
		 if ((player1SetScore - player2SetScore) >= 1) {
			 setWinner = "team1";
		 } else {
			 setWinner = "team2";
		 }
		 if (currentSet == 1) {
			 this.state.set1Winner = setWinner;
			 console.log("Set 1 Winner" + ": " + this.state.set1Winner);
			 if (!nextSetEnabled) {
				 this.state.matchWinner = this.state.set1Winner;
			 }
		 } else if (currentSet == 2) {
			 this.state.set2Winner = setWinner;
			 console.log("Set 2 Winner" + ": " + this.state.set2Winner);
			 if (this.state.set2Winner == this.state.set1Winner) {
				 this.state.matchWinner = this.state.set2Winner;
			 }
		 } else if (currentSet == 3) {
			 this.state.set3Winner = setWinner;
			 console.log("Set 3 Winner" + ": " + this.state.set3Winner);
			 if (this.state.set1Winner == this.state.set3Winner) {
				 this.state.matchWinner = this.state.set3Winner;
			 } else if (this.state.set2Winner == this.state.set3Winner) {
				 this.state.matchWinner = this.state.set3Winner;
			 }
		 }
	 }
 
	 validateScores(player1_set_score_input, player2_set_score_input) {
		 if (player1_set_score_input.value == '') {
			 if (player1_set_score_input != null) {
				 player1_set_score_input.focus();
				 this._showNextBtn.classList.add('u-hidden');
				 return false;
			 }
		 }
		 if (player2_set_score_input.value == '') {
			 if (player2_set_score_input != null) {
				 player2_set_score_input.focus();
				 this._showNextBtn.classList.add('u-hidden');
				 return false;
			 }
		 }
		 return true;
	 }
 
	 checkForm(event) {
		 let inputChanged = event.target,
			 manualSinglesSection = false,
			 manualPartnerSection = false,
			 manualOpponent1Section = false,
			 manualOpponent2Section = false;
		 if (this.state.section == 0) {
			 this.state.selectedVenue = this.state.favVenues.filter(i => i.id == event.target.value);
			 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-venue-selected').classList.remove('u-hidden');
			 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-without-venue').classList.add('u-hidden');
			 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-venue-selected').scrollIntoView();
		 }
		 if (this.state.currentEventSection == 1) {
			 if (!this.checkIfEmptyObj(this.state.getDefaultParams) && this.state.stepManual) {
				 if (inputChanged.value == 'Singles' || inputChanged.value == 'Doubles') {
					 this.state.matchFormat = inputChanged.value;
					 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.remove("u-hidden");
					 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').scrollIntoView();
				 }
			 } else {
				 if (inputChanged.value == 'Tennis' || inputChanged.value == 'Padel') {
					 this.state.sportPlayed = inputChanged.value;
				 } else if (inputChanged.value == 'Singles' || inputChanged.value == 'Doubles') {
					 this.state.matchFormat = inputChanged.value;
				 } else if (inputChanged.value == 'Yellow' || inputChanged.value == 'Green' || inputChanged.value == 'Orange' || inputChanged.value == 'Red') {
					 this.state.tennisBallColor = inputChanged.value;
				 } else if (inputChanged.value == 'Friendly' || inputChanged.value == 'Competition') {
					 this.state.matchCategory = inputChanged.value;
				 }
 
				 if (inputChanged.closest(".js-lta-section-content").nextElementSibling == null) {
					 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.remove('u-hidden');
					 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').scrollIntoView();
				 } else {
					 if (this.state.sportPlayed == 'Tennis') {
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.classList.remove("u-hidden");
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.scrollIntoView();
						 if (this.state.matchFormat !== '') {
							 document.querySelector("input[name='tennisType'][value=" + this.state.matchFormat + "]").checked = true;
							 inputChanged.closest(".js-lta-section-content").nextElementSibling.classList.remove("u-hidden");
							 inputChanged.closest(".js-lta-section-content").nextElementSibling.scrollIntoView();
						 }
						 if (this.state.tennisBallColor !== '') {
							 document.querySelector("input[name='tennisBallColor'][value=" + this.state.tennisBallColor + "]").checked = true;
							 inputChanged.closest(".js-lta-section-content")?.nextElementSibling?.nextElementSibling?.classList.remove("u-hidden");
							 inputChanged.closest(".js-lta-section-content")?.nextElementSibling?.nextElementSibling?.scrollIntoView();
						 }
						 if (this.state.matchCategory !== '') {
							 document.querySelector("input[name='matchCategory'][value=" + this.state.matchCategory + "]").checked = true;
							 inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.nextElementSibling.classList.remove("u-hidden");
							 inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.nextElementSibling.scrollIntoView();
						 }
					 }
					 if (this.state.sportPlayed == 'Padel') {
						 this.state.matchFormat = 'Doubles';
						 this.state.tennisBallColor = 'Yellow';
						 Array.from(inputChanged.closest(".js-lta-section-content").nextElementSibling.querySelectorAll('input[type="radio"]'), y => y.checked = false);
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.classList.add("u-hidden");
						 Array.from(inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.querySelectorAll('input[type="radio"]'), y => y.checked = false);
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.classList.add("u-hidden");
						 Array.from(inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.nextElementSibling.querySelectorAll('input[type="radio"]'), y => y.checked = false);
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.nextElementSibling.classList.remove("u-hidden");
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.nextElementSibling.scrollIntoView();
						 inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.nextElementSibling.querySelector('.js-next-section').classList.add('u-hidden');
					 }
				 }
			 }
		 }
		 if (this.state.currentEventSection == 2) {
			 // Singles Opponent
			 if (inputChanged.id == 'firstName') {
				 this.state.playerFirstName = inputChanged.value;
				 this.state.selectedPlayer[0].id = '';
				 this.state.selectedPlayer[0].gender = '';
				 this.state.selectedPlayer[0].ltanumber = '';
				 this.state.selectedPlayer[0].contactid = '';
				 this.state.selectedPlayer[0].city = '';
				 this.state.selectedPlayer[0].county = '';
				 this.state.selectedPlayer[0].town = '';
				 this.state.selectedPlayer[0]["firstname"] = inputChanged.value;
				 manualSinglesSection = true;
			 }
			 if (inputChanged.id == 'lastName') {
				 this.state.playerLastName = inputChanged.value;
				 this.state.selectedPlayer[0].id = '';
				 this.state.selectedPlayer[0].gender = '';
				 this.state.selectedPlayer[0].ltanumber = '';
				 this.state.selectedPlayer[0].contactid = '';
				 this.state.selectedPlayer[0].city = '';
				 this.state.selectedPlayer[0].county = '';
				 this.state.selectedPlayer[0].town = '';
				 this.state.selectedPlayer[0]["lastname"] = inputChanged.value;
				 manualSinglesSection = true;
				 this.state.singlesReferralCode = Math.floor(Math.random() * 90000) + 10000;
			 }
			 // Doubles Partner
			 if (inputChanged.id == 'partnerFirstName') {
				 this.state.selectedPartner[0].id = '';
				 this.state.selectedPartner[0].gender = '';
				 this.state.selectedPartner[0].ltanumber = '';
				 this.state.selectedPartner[0].contactid = '';
				 this.state.selectedPartner[0].city = '';
				 this.state.selectedPartner[0].county = '';
				 this.state.selectedPartner[0].town = '';
				 this.state.partnerFirstName = inputChanged.value;
				 this.state.selectedPartner[0]["firstname"] = inputChanged.value;
				 manualPartnerSection = true;
			 }
			 if (inputChanged.id == 'partnerLastName') {
				 this.state.partnerLastName = inputChanged.value;
				 this.state.selectedPartner[0].id = '';
				 this.state.selectedPartner[0].gender = '';
				 this.state.selectedPartner[0].ltanumber = '';
				 this.state.selectedPartner[0].contactid = '';
				 this.state.selectedPartner[0].city = '';
				 this.state.selectedPartner[0].county = '';
				 this.state.selectedPartner[0].town = '';
				 this.state.selectedPartner[0]["lastname"] = inputChanged.value;
				 manualPartnerSection = true;
				 this.state.partnerRefferalCode = Math.floor(Math.random() * 90000) + 10000;
			 }
			 // Doubles Opponent1
			 if (inputChanged.id == 'opponent1FirstName') {
				 this.state.opponent1FirstName = inputChanged.value;
				 this.state.selectedOpponent1[0].id = '';
				 this.state.selectedOpponent1[0].gender = '';
				 this.state.selectedOpponent1[0].ltanumber = '';
				 this.state.selectedOpponent1[0].contactid = '';
				 this.state.selectedOpponent1[0].city = '';
				 this.state.selectedOpponent1[0].county = '';
				 this.state.selectedOpponent1[0].town = '';
				 this.state.selectedOpponent1[0]["firstname"] = inputChanged.value;
				 manualOpponent1Section = true;
			 }
			 if (inputChanged.id == 'opponent1LastName') {
				 this.state.opponent1LastName = inputChanged.value;
				 this.state.selectedOpponent1[0].id = '';
				 this.state.selectedOpponent1[0].gender = '';
				 this.state.selectedOpponent1[0].ltanumber = '';
				 this.state.selectedOpponent1[0].contactid = '';
				 this.state.selectedOpponent1[0].city = '';
				 this.state.selectedOpponent1[0].county = '';
				 this.state.selectedOpponent1[0].town = '';
				 this.state.selectedOpponent1[0]["lastname"] = inputChanged.value;
				 manualOpponent1Section = true;
				 this.state.opponent1ReferralCode = Math.floor(Math.random() * 90000) + 10000;
			 }
			 // Doubles Opponent2
			 if (inputChanged.id == 'opponent2FirstName') {
				 this.state.opponent2FirstName = inputChanged.value;
				 this.state.selectedOpponent2[0].id = '';
				 this.state.selectedOpponent2[0].gender = '';
				 this.state.selectedOpponent2[0].ltanumber = '';
				 this.state.selectedOpponent2[0].contactid = '';
				 this.state.selectedOpponent2[0].city = '';
				 this.state.selectedOpponent2[0].county = '';
				 this.state.selectedOpponent2[0].town = '';
				 this.state.selectedOpponent2[0]["firstname"] = inputChanged.value;
				 manualOpponent2Section = true;
			 }
			 if (inputChanged.id == 'opponent2LastName') {
				 this.state.opponent2LastName = inputChanged.value;
				 this.state.selectedOpponent2[0].id = '';
				 this.state.selectedOpponent2[0].gender = '';
				 this.state.selectedOpponent2[0].ltanumber = '';
				 this.state.selectedOpponent2[0].contactid = '';
				 this.state.selectedOpponent2[0].city = '';
				 this.state.selectedOpponent2[0].county = '';
				 this.state.selectedOpponent2[0].town = '';
				 this.state.selectedOpponent2[0]["lastname"] = inputChanged.value;
				 manualOpponent2Section = true;
				 this.state.opponent2ReferralCode = Math.floor(Math.random() * 90000) + 10000;
			 }
			 if (inputChanged.type == 'radio') {
				 this.updateNextButtonStatus(inputChanged.id);
				 if (this.state.matchFormat == 'Singles' && !manualSinglesSection) {
					 this.state.selectedPlayer = JSON.parse(this.state.favPlayers).filter(i => i.id == event.target.value);
					 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-player-selected').classList.remove('u-hidden');
					 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-player-selected').scrollIntoView();
				 }
				 if (this.state.matchFormat == 'Doubles') {
					 if (!(this.state.partnerNextButton || this.state.partnerOpponent1Button || this.state.partnerOpponent2Button)) {
						 this.state.partnerNextButton = true;
					 }
					 if (this.state.partnerNextButton && !manualPartnerSection) {
						 this.state.partnerNextButton = false;
						 this.state.partnerOpponent1Button = true;
						 this.state.selectedPartner = JSON.parse(this.state.favPlayers).filter(i => i.id == event.target.value);
						 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-partner-player-selected').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-partner-player-selected').scrollIntoView();
					 } else if (this.state.partnerOpponent1Button && !this.state.partnerOpponent2Button && !manualOpponent1Section) {
						 this.state.partnerOpponent1Button = false;
						 this.state.partnerOpponent2Button = true;
						 this.state.selectedOpponent1 = JSON.parse(this.state.favPlayers).filter(i => i.id == event.target.value);
						 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-opponent1-player-selected').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-opponent1-player-selected').scrollIntoView();
					 } else if (this.state.partnerOpponent2Button && !manualOpponent2Section && !manualOpponent1Section) {
						 this.state.partnerOpponent2Button = false;
						 this.state.selectedOpponent2 = JSON.parse(this.state.favPlayers).filter(i => i.id == event.target.value);
						 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-opponent2-player-selected').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.lta-btn-opponent2-player-selected').scrollIntoView();
					 }
				 }
			 }
			 if (inputChanged.type == 'text') {
				 if (this.state.matchFormat == 'Singles') {
					 // Singles Manual First and Last name
					 if (this.state.playerFirstName && this.state.playerLastName && manualSinglesSection) {
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').scrollIntoView();
					 } else {
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.add('u-hidden');
					 }
				 }
				 if (this.state.matchFormat == 'Doubles') {
					 if (this.state.partnerFirstName && this.state.partnerLastName && manualPartnerSection) {
						 // Partner Manual First and Last name
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').scrollIntoView();
					 } else if (manualPartnerSection) {
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.add('u-hidden');
					 }
					 if (this.state.opponent1FirstName && this.state.opponent1LastName && manualOpponent1Section) {
						 // Opponent1 Manual First and Last name
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').scrollIntoView();
					 } else if (manualOpponent1Section) {
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.add('u-hidden');
					 }
					 if (this.state.opponent2FirstName && this.state.opponent2LastName && manualOpponent2Section) {
						 // Opponent2 Manual First and Last name
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.remove('u-hidden');
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').scrollIntoView();
					 } else if (manualOpponent2Section) {
						 inputChanged.closest(".js-lta-section-content").querySelector('.js-next-section').classList.add('u-hidden');
					 }
				 }
			 }
		 }
	 }
 
	 updateNextButtonStatus(id) {
		 //Doubles
		 if (id.includes('DoublesPartner')) {
			 this.state.partnerNextButton = false;
			 this.state.partnerOpponent1Button = false;
			 this.state.partnerOpponent2Button = false;
		 }
		 //Opponent1
		 if (id.includes('DoublesOpponent1')) {
			 this.state.partnerNextButton = false;
			 this.state.partnerOpponent1Button = true;
			 this.state.partnerOpponent2Button = false;
		 }
		 //Opponent2
		 if (id.includes('DoublesOpponent2')) {
			 this.state.partnerNextButton = false;
			 this.state.partnerOpponent1Button = true;
			 this.state.partnerOpponent2Button = true;
		 }
	 }
 
	 exitJourney() {
		 this._modalTriggerSSBtn.disabled = true;
		 this._exitModal.hide();
		 this._successModal.hide();
		 this._modal.hide();
		 // this.resetJourney();
		 if (this.state.isSubmitted) {
			 // this.resetSSData();
			 setTimeout(() => location.reload(true), 300);
		 }
	 }
 
 
	 resetJourney() {
		 const currentPosition = this.state.section;
		 if (currentPosition !== 0) {
			 this._sections[0].children.item(currentPosition).classList.add('u-hidden');
			 this._sections[0].children.item(0).classList.remove('u-hidden');
			 this.state.section = 0;
		 }
 
		 this._sections.forEach((section) => {
			 const parts = section.querySelectorAll('.js-lta-section-content');
			 parts.forEach((part, i) => {
				 if (i === 0) {
					 part.classList.remove('u-hidden');
				 } else {
					 part.classList.add('u-hidden');
				 }
			 });
		 });
 
		 sessionStorage.ltaOnboardingExit = true;
	 }
 
	 goToNextSection() {
		 let currentPosition = this.state.section;
		 if (currentPosition + 1 < this._sections[0].children.length) {
			 this._sections[0].children.item(currentPosition + 1).classList.add('u-hidden');
			 if (currentPosition == 0) {
				 this.state.selectedVenue = this.ssVenueSearchEl.state.venues.length > 0 ? this.ssVenueSearchEl.state.venues : this.state.selectedVenue;
				 if (!(this.state.stepDefault || this.state.stepManual)) {
					 this.state.stepDefault = true;
				 }
				 document.getElementById('manual-game-param-section').classList.add('u-hidden');
				 document.getElementById('defaults-game-param-section').classList.add('u-hidden');
				 if (this.checkIfEmptyObj(this.state.getDefaultParams)) {
					 this.state.stepManual = true;
					 document.getElementById('manual-game-param-section').classList.remove('u-hidden');
					 document.getElementById('manual-game-param-section').scrollIntoView();
				 } else {
					 if (this.state.getDefaultParams.sport != null && this.state.getDefaultParams.sport != '') {
						 document.querySelector('.defaults-container form').children.item(0).children.item(1).innerText = this.state.getDefaultParams.sport;
					 } else {
						 document.querySelector('.defaults-container form').children.item(0).children.item(0).classList.add('u-hidden');
						 document.querySelector('.defaults-container form').children.item(0).children.item(1).innerText = '';
					 }
					 if (this.state.getDefaultParams.ballColor != null && this.state.getDefaultParams.ballColor != '') {
						 document.querySelector('.defaults-container form').children.item(1).children.item(1).innerText = this.state.getDefaultParams.ballColor;
					 } else {
						 document.querySelector('.defaults-container form').children.item(1).children.item(0).classList.add('u-hidden');
						 document.querySelector('.defaults-container form').children.item(1).children.item(1).innerText = '';
					 }
					 if (this.state.getDefaultParams.matchCategory != null && this.state.getDefaultParams.matchCategory != '') {
						 document.querySelector('.defaults-container form').children.item(2).children.item(0).children.item(1).innerText = this.state.getDefaultParams.matchCategory;
					 } else {
						 document.querySelector('.defaults-container form').children.item(2).children.item(0).children.item(0).classList.add('u-hidden');
						 document.querySelector('.defaults-container form').children.item(2).children.item(0).children.item(1).innerText = '';
					 }
					 if (this.state.getDefaultParams.sport == 'Padel') {
						 document.querySelector('.tennis-ball-color-section').classList.add('u-hidden');
						 document.querySelector('.your-game-sport-type').classList.add('u-hidden');
						 document.getElementById('defaults-game-param-section').querySelector('.js-next-section').classList.remove('u-hidden');
						 document.getElementById('defaults-game-param-section').querySelector('.js-next-section').scrollIntoView();
					 } else if (this.state.getDefaultParams.sport == 'Tennis') {
						 document.querySelector('.your-game-sport-type').classList.remove('u-hidden');
						 document.querySelector('.your-game-sport-type').scrollIntoView();
						 document.getElementById('defaults-game-param-section').querySelector('.js-next-section').classList.add('u-hidden');
					 }
					 document.getElementById('defaults-game-param-section').classList.remove('u-hidden');
					 document.getElementById('defaults-game-param-section').scrollIntoView();
				 }
				 this.conditionalNextSection(currentPosition, true);
			 }
			 if (currentPosition == 1) {
				 document.querySelector('.player-search-single').classList.add('u-hidden');
				 document.querySelector('.player-search-doubles-partner').classList.add('u-hidden');
				 document.querySelector('.player-search-doubles-opponents1').classList.add('u-hidden');
				 document.querySelector('.player-search-doubles-opponents2').classList.add('u-hidden');
				 if (!this.validatePreviousPageInputs(currentPosition)) {
					 this._sections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
					 this._sections[0].children.item(currentPosition + 1).scrollIntoView();
					 return;
				 }
				 if (this.state.matchFormat == 'Singles') {
					 this.clearDoublesPlayerData();
					 this.state.currentEventSection = 2;
					 this.displayPlayerSection(null, this.state.playerDataAttributes.singlesOpponent);
					 this.conditionalNextSection(currentPosition, true);
				 } else if (this.state.matchFormat == 'Doubles') {
					 this.clearSinglesPlayerData();
					 if (!(this.state.stepPartner || this.state.stepOpponent1 || this.state.stepOpponent2)) {
						 this.state.stepPartner = true;
					 }
					 if (this.state.stepPartner) {
						 this.state.currentEventSection = 2;
						 this.state.stepPartner = false;
						 this.state.stepOpponent1 = true;
						 this.displayPlayerSection(null, this.state.playerDataAttributes.doublesPartner);
						 this.conditionalNextSection(currentPosition, false);
					 } else if (this.state.stepOpponent1) {
						 this.state.stepPartner = false;
						 this.state.stepOpponent1 = false;
						 this.state.stepOpponent2 = true;
						 this.displayPlayerSection(null, this.state.playerDataAttributes.doublesOpponent1);
						 this.conditionalNextSection(currentPosition, false);
					 } else if (this.state.stepOpponent2) {
						 this.state.stepPartner = false;
						 this.state.stepOpponent1 = false;
						 this.state.stepOpponent2 = false;
						 this.displayPlayerSection(null, this.state.playerDataAttributes.doublesOpponent2);
						 this.conditionalNextSection(currentPosition, true);
					 }
				 }
			 }
			 else if (currentPosition == 2) {
				 if (this.state.matchFormat == 'Doubles' && !this.validateSamePlayerSelected()) {
					 this._sections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
					 this._sections[0].children.item(currentPosition + 1).scrollIntoView();
					 return;
				 }
				 this.state.currentEventSection = 3;
 
				 if (this.state.matchFormat == 'Singles') {
					 document.querySelector('.player2-name').innerHTML = '';
					 document.querySelector('.player1-partnerName').innerHTML = '';
					 document.querySelector('.player2-partnerName').innerHTML = '';
					 document.querySelector('.player1-name').innerHTML = this.state.myContactName;
					 if (this.ssPlayerSearchEl.state.players.length > 0) {
						 this.state.selectedPlayer = this.ssPlayerSearchEl.state.players;
						 document.querySelector('.player2-name').innerHTML = this.state.selectedPlayer[0].firstname + ' ' + this.state.selectedPlayer[0].lastname;
					 } else {
						 document.querySelector('.player2-name').innerHTML = this.state.selectedPlayer.length > 0 ? this.state.selectedPlayer[0].firstname + ' ' + this.state.selectedPlayer[0].lastname : "";
					 }
				 } else if (this.state.matchFormat == 'Doubles') {
					 document.querySelector('.player2-name').innerHTML = '';
					 document.querySelector('.player1-name').innerHTML = this.state.myContactName;
					 if (this.ssPartnerSearchEl.state.players.length > 0) {
						 this.state.selectedPartner = this.ssPartnerSearchEl.state.players;
						 document.querySelector('.player1-partnerName').innerHTML = this.state.selectedPartner.length > 0 ? this.state.selectedPartner[0].firstname + ' ' + this.state.selectedPartner[0].lastname : "";
					 } else {
						 document.querySelector('.player1-partnerName').innerHTML = this.state.selectedPartner.length > 0 ? this.state.selectedPartner[0].firstname + ' ' + this.state.selectedPartner[0].lastname : "";
					 }
					 if (this.ssOpponent1SearchEl.state.players.length > 0) {
						 this.state.selectedOpponent1 = this.ssOpponent1SearchEl.state.players;
						 document.querySelector('.player2-name').innerHTML = this.state.selectedOpponent1.length > 0 ? this.state.selectedOpponent1[0].firstname + ' ' + this.state.selectedOpponent1[0].lastname : "";
					 } else {
						 document.querySelector('.player2-name').innerHTML = this.state.selectedOpponent1.length > 0 ? this.state.selectedOpponent1[0].firstname + ' ' + this.state.selectedOpponent1[0].lastname : "";
					 }
					 if (this.ssOpponent2SearchEl.state.players.length > 0) {
						 this.state.selectedOpponent2 = this.ssOpponent2SearchEl.state.players;
						 document.querySelector('.player2-partnerName').innerHTML = this.state.selectedOpponent2.length > 0 ? this.state.selectedOpponent2[0].firstname + ' ' + this.state.selectedOpponent2[0].lastname : "";
					 } else {
						 document.querySelector('.player2-partnerName').innerHTML = this.state.selectedOpponent2.length > 0 ? this.state.selectedOpponent2[0].firstname + ' ' + this.state.selectedOpponent2[0].lastname : "";
					 }
				 }
				 this.getDeduplicationData();
				 this.conditionalNextSection(currentPosition, true);
			 }
			 else if (currentPosition == 3) {
				 this.state.currentEventSection = 4;
				 this._stepSections[0].classList.add('u-hidden');
				 const modifiedDate = new Date(this.state.dateValue);
				 document.querySelector('.match-date-container').children[1].innerText = modifiedDate.toLocaleDateString("en-UK");
				 this.fillSummaryVenueDetails();
				 this.fillSummaryMatchDetails();
				 this.fillSummaryPlayerDetails();
				 this.fillSummaryScoreFormats();
				 this.fillMatchWinnerDetails();
				 this._sections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
				 document.querySelector('.js-self-submision-back').scrollTo(0, 0);
			 }
			 else {
				 this.state.currentEventSection = this.state.currentEventSection + 1;
				 this.conditionalNextSection(currentPosition, true);
			 }
		 }
	 }
 
	 checkIfManualPlayerDataExists(playerAttributes) {
		 let bool = false;
		 if (playerAttributes.selectedPlayerSearchType === 'Opponent') {
			 if (this.state.playerFirstName && this.state.playerLastName) {
				 bool = true;
			 }
		 } else if (playerAttributes.selectedPlayerSearchType === 'Partner') {
			 if (this.state.partnerFirstName && this.state.partnerLastName) {
				 bool = true;
			 }
		 } else if (playerAttributes.selectedPlayerSearchType === 'Opponent1') {
			 if (this.state.opponent1FirstName && this.state.opponent1LastName) {
				 bool = true;
			 }
		 } else if (playerAttributes.selectedPlayerSearchType === 'Opponent2') {
			 if (this.state.opponent2FirstName && this.state.opponent2LastName) {
				 bool = true;
			 }
		 }
		 return bool;
	 }
 
	 checkIfPlayerSelectedDataExists(playerAttributes) {
		 let bool = false;
		 if (playerAttributes.selectedPlayerSearchType === 'Opponent') {
			 if (this.ssPlayerSearchEl.state.players.length > 0) {
				 bool = true;
			 }
		 } else if (playerAttributes.selectedPlayerSearchType === 'Partner') {
			 if (this.ssPartnerSearchEl.state.players.length > 0) {
				 bool = true;
			 }
		 } else if (playerAttributes.selectedPlayerSearchType === 'Opponent1') {
			 if (this.ssOpponent1SearchEl.state.players.length > 0) {
				 bool = true;
			 }
		 } else if (playerAttributes.selectedPlayerSearchType === 'Opponent2') {
			 if (this.ssOpponent2SearchEl.state.players.length > 0) {
				 bool = true;
			 }
		 }
		 return bool;
	 }
 
	 checkIfPlayerListTemplateSelected(playerAttributes) {
		 let bool = false;
		 if (playerAttributes.playerListTemplateName === 'recentPlayerListTemplate') {
			 if (Object.values(this.state.selectedPlayer[0]).length > 0) {
				 bool = true;
			 }
		 } else if (playerAttributes.playerListTemplateName === 'recentPartnerPlayerListTemplate') {
			 if (Object.values(this.state.selectedPartner[0]).length > 0) {
				 bool = true;
			 }
		 } else if (playerAttributes.playerListTemplateName === 'recentOpponent1PlayerListTemplate') {
			 if (Object.values(this.state.selectedOpponent1[0]).length > 0) {
				 bool = true;
			 }
		 } else if (playerAttributes.playerListTemplateName === 'recentOpponent2PlayerListTemplate') {
			 if (Object.values(this.state.selectedOpponent2[0]).length > 0) {
				 bool = true;
			 }
		 }
		 return bool;
	 }
 
	 checkIfPlayerListTemplateExists(playerAttributes) {
		 let bool = false;
		 if (playerAttributes.playerListTemplateName === 'recentPlayerListTemplate') {
			 if (this.state.recentPlayerListTemplate) {
				 bool = true;
			 }
		 } else if (playerAttributes.playerListTemplateName === 'recentPartnerPlayerListTemplate') {
			 if (this.state.recentPartnerPlayerListTemplate) {
				 bool = true;
			 }
		 } else if (playerAttributes.playerListTemplateName === 'recentOpponent1PlayerListTemplate') {
			 if (this.state.recentOpponent1PlayerListTemplate) {
				 bool = true;
			 }
		 } else if (playerAttributes.playerListTemplateName === 'recentOpponent2PlayerListTemplate') {
			 if (this.state.recentOpponent2PlayerListTemplate) {
				 bool = true;
			 }
		 }
		 return bool;
	 }
 
	 clearPlayerAttributes(playerAttributes) {
		 SelectorEngine.findOne(playerAttributes.playerFirstName).value = '';
		 SelectorEngine.findOne(playerAttributes.playerLastName).value = '';
		 if (playerAttributes.selectedPlayerSearchType === 'Opponent') {
			 this.state.playerFirstName = '';
			 this.state.playerLastName = '';
		 } else if (playerAttributes.selectedPlayerSearchType === 'Partner') {
			 this.state.partnerFirstName = '';
			 this.state.partnerLastName = '';
		 } else if (playerAttributes.selectedPlayerSearchType === 'Opponent1') {
			 this.state.opponent1FirstName = '';
			 this.state.opponent1LastName = '';
		 } else if (playerAttributes.selectedPlayerSearchType === 'Opponent2') {
			 this.state.opponent2FirstName = '';
			 this.state.opponent2LastName = '';
		 }
	 }
 
	 clearDoublesPlayerData() {
		 // clear partner fav data
		 document.querySelectorAll('.js-favourite-partner-player-list input').forEach(el => el.checked = false);
		 this.state.selectedPartner = [{}];
		 // clear partner player search data
		 document.getElementById('cant-find-partner-section')?.querySelector('.lta-player-ss-search--players')?.querySelector('.lta-player-ss-search--remove')?.click();
		 this.state.selectedPartner = [{}];
		 // clear partner manual data
		 SelectorEngine.findOne('#partnerFirstName').value = '';
		 SelectorEngine.findOne('#partnerLastName').value = '';
		 this.state.partnerFirstName = '';
		 this.state.partnerLastName = '';
 
 
		 // clear opponent 1 fav data
		 document.querySelectorAll('.js-favourite-opponent1-player-list input').forEach(el => el.checked = false);
		 this.state.selectedOpponent1 = [{}];
		 // clear opponent 1 player search data
		 document.getElementById('cant-find-doubles-opponent1-section')?.querySelector('.lta-player-ss-search--players')?.querySelector('.lta-player-ss-search--remove')?.click();
		 this.state.selectedOpponent1 = [{}];
		 // clear opponent 1 manual data
		 SelectorEngine.findOne('#opponent1FirstName').value = '';
		 SelectorEngine.findOne('#opponent1LastName').value = '';
		 this.state.opponent1FirstName = '';
		 this.state.opponent1LastName = '';
 
		 // clear opponent 2 fav data
		 document.querySelectorAll('.js-favourite-opponent2-player-list input').forEach(el => el.checked = false);
		 this.state.selectedOpponent2 = [{}];
		 // clear opponent 2 player search data
		 document.getElementById('cant-find-doubles-opponent2-section')?.querySelector('.lta-player-ss-search--players')?.querySelector('.lta-player-ss-search--remove')?.click();
		 this.state.selectedOpponent1 = [{}];
		 // clear opponent 1 manual data
		 SelectorEngine.findOne('#opponent2FirstName').value = '';
		 SelectorEngine.findOne('#opponent2LastName').value = '';
		 this.state.opponent2FirstName = '';
		 this.state.opponent2LastName = '';
	 }
 
	 clearSinglesPlayerData() {
		 // clear favourite data
		 document.querySelectorAll('.js-favourite-singles-player-list input').forEach(el => el.checked = false);
		 this.state.selectedPlayer = [{}];
		 // clear player search data
		 document.getElementById('cant-find-opponent-section')?.querySelector('.lta-player-ss-search--players')?.querySelector('.lta-player-ss-search--remove')?.click();
		 this.state.selectedPlayer = [{}];
		 // clear singles manual data
		 SelectorEngine.findOne('#firstName').value = '';
		 SelectorEngine.findOne('#lastName').value = '';
		 this.state.playerFirstName = '';
		 this.state.playerLastName = '';
	 }
 
	 displayPlayerSection(buttonActionEvent, playerAttributes) {
		 document.querySelector(playerAttributes.playerSection).classList.remove('u-hidden');
		 document.querySelector(playerAttributes.playerSection).scrollIntoView();
		 // Reset opponent section
		 document.getElementById(playerAttributes.favouritePlayerSection).classList.add('u-hidden');
		 document.getElementById(playerAttributes.manualPlayerSection).classList.add('u-hidden');
		 document.getElementById(playerAttributes.playerSearchSection).classList.add('u-hidden');
 
		 // Button Action Events
		 if (buttonActionEvent === 'cantFindSingleOpponent') {
			 // Show Manual Section
			 document.getElementById(playerAttributes.playerSearchSection).classList.add("u-hidden");
			 document.getElementById(playerAttributes.manualPlayerSection).classList.remove("u-hidden");
			 document.getElementById(playerAttributes.manualPlayerSection).scrollIntoView();
			 document.getElementById(playerAttributes.playerSearchSection)?.querySelector('.lta-player-ss-search--players')?.querySelector('.lta-player-ss-search--remove')?.click();
			 document.getElementById(playerAttributes.manualPlayerSection)?.querySelector(playerAttributes.searchPlayerAgainBtn)?.classList.remove('u-hidden');
			 if (this.checkIfPlayerListTemplateExists(playerAttributes)) {
				 document.getElementById(playerAttributes.manualPlayerSection)?.querySelector(playerAttributes.showFavouritesBtn)?.classList.remove('u-hidden');
			 } else {
				 document.getElementById(playerAttributes.manualPlayerSection)?.querySelector(playerAttributes.showFavouritesBtn)?.classList.add('u-hidden');
			 }
		 } else if (buttonActionEvent === 'singlesPlayerSearchAgain') {
			 // Player Search
			 document.getElementById(playerAttributes.playerSearchSection).classList.remove("u-hidden");
			 document.getElementById(playerAttributes.manualPlayerSection).classList.add("u-hidden");
			 this.clearPlayerAttributes(playerAttributes);
			 document.getElementById(playerAttributes.manualPlayerSection)?.querySelector(playerAttributes.nextBtn)?.classList.add('u-hidden');
			 document.querySelector(playerAttributes.noOpponentBtn).classList.remove('u-hidden');
			 document.getElementById(playerAttributes.playerSearchSection).scrollIntoView();
			 if (this.checkIfPlayerListTemplateExists(playerAttributes)) {
				 document.getElementById(playerAttributes.playerSearchSection)?.querySelector(playerAttributes.showFavouritesSearchBtn)?.classList.remove('u-hidden');
			 } else {
				 document.getElementById(playerAttributes.playerSearchSection)?.querySelector(playerAttributes.showFavouritesSearchBtn)?.classList.add('u-hidden');
			 }
		 } else if (buttonActionEvent === 'showFavourites') {
			 document.getElementById(playerAttributes.favouritePlayerSection).classList.remove("u-hidden");
			 document.getElementById(playerAttributes.favouritePlayerSection).scrollIntoView();
			 document.getElementById(playerAttributes.playerSearchSection).classList.add("u-hidden");
			 document.querySelector(playerAttributes.playerSearchBtnLink).classList.remove("u-hidden");
			 document.querySelector(playerAttributes.playerSearchBtnLink).scrollIntoView();
			 // Remove Selected player from search
			 document.getElementById(playerAttributes.playerSearchSection)?.querySelector('.lta-player-ss-search--players')?.querySelector('.lta-player-ss-search--remove')?.click();
			 document.getElementById(playerAttributes.manualPlayerSection).classList.add("u-hidden");
			 // Remove Manual player data
			 this.clearPlayerAttributes(playerAttributes);
			 document.getElementById(playerAttributes.favouritePlayerSection)?.querySelector(playerAttributes.nextBtn)?.classList.add('u-hidden');
			 document.getElementById(playerAttributes.manualPlayerSection)?.querySelector(playerAttributes.nextBtn)?.classList.add('u-hidden');
		 } else if (this.checkIfManualPlayerDataExists(playerAttributes)) {
			 // Show manual if manual data exists
			 document.getElementById(playerAttributes.manualPlayerSection).classList.remove('u-hidden');
			 document.getElementById(playerAttributes.manualPlayerSection).scrollIntoView();
		 } else if (this.checkIfPlayerSelectedDataExists(playerAttributes)) {
			 // Show player search if card exists
			 document.getElementById(playerAttributes.playerSearchSection).classList.remove('u-hidden');
			 document.getElementById(playerAttributes.playerSearchSection).scrollIntoView();
		 } else if (this.checkIfPlayerListTemplateSelected(playerAttributes) || this.checkIfPlayerListTemplateExists(playerAttributes)) {
			 // Show favourite if favourite data exists
			 const favPlayerList = document.querySelector(playerAttributes.playerList);
			 if (playerAttributes.playerListTemplateName === 'recentPlayerListTemplate') {
				 favPlayerList.append(this.state.recentPlayerListTemplate);
			 } else if (playerAttributes.playerListTemplateName === 'recentPartnerPlayerListTemplate') {
				 favPlayerList.append(this.state.recentPartnerPlayerListTemplate);
			 } else if (playerAttributes.playerListTemplateName === 'recentOpponent1PlayerListTemplate') {
				 favPlayerList.append(this.state.recentOpponent1PlayerListTemplate);
			 } else if (playerAttributes.playerListTemplateName === 'recentOpponent2PlayerListTemplate') {
				 favPlayerList.append(this.state.recentOpponent2PlayerListTemplate);
			 }
			 document.getElementById(playerAttributes.favouritePlayerSection).classList.remove('u-hidden');
			 document.querySelector(playerAttributes.playerSearchBtnLink).classList.remove("u-hidden");
			 document.getElementById(playerAttributes.favouritePlayerSection).scrollIntoView();
		 } else {
			 // Show new player search component if no favourites available
			 document.getElementById(playerAttributes.playerSearchSection).classList.remove('u-hidden');
			 document.getElementById(playerAttributes.playerSearchSection)?.querySelector(playerAttributes.showFavouritesSearchBtn)?.classList.add('u-hidden');
			 document.getElementById(playerAttributes.playerSearchSection).scrollIntoView();
		 }
	 }
 
	 checkIfEmptyObj(obj) {
		 for (var key in obj) {
			 if (obj[key] !== null && obj[key] != "" && key != 'firstTimeSubmission')
				 return false;
		 }
		 return true;
	 }
 
	 validateSamePlayerSelected() {
		 // Take inputs for selected partner
		 let partnerContactId;
		 if (this.state.selectedPartner[0].id) {
			 partnerContactId = this.state.selectedPartner[0].id;
		 } else if (this.ssPartnerSearchEl.state.players.length > 0 && this.ssPartnerSearchEl.state.players[0].id) {
			 partnerContactId = this.ssPartnerSearchEl.state.players[0].id;
		 } else {
			 partnerContactId = this.state.selectedPartner[0].firstname + ' ' + this.state.selectedPartner[0].lastname;
		 }
 
		 // Take inputs for selected opponent1
		 let opponent1ContactId;
		 if (this.state.selectedOpponent1[0].id) {
			 opponent1ContactId = this.state.selectedOpponent1[0].id;
		 } else if (this.ssOpponent1SearchEl.state.players.length > 0 && this.ssOpponent1SearchEl.state.players[0].id) {
			 this.ssOpponent1SearchEl.state.players[0].id
		 } else {
			 opponent1ContactId = this.state.selectedOpponent1[0].firstname + ' ' + this.state.selectedOpponent1[0].lastname;
		 }
 
		 // Take inputs for selected opponent2
		 let opponent2ContactId;
		 if (this.state.selectedOpponent2[0].id) {
			 opponent2ContactId = this.state.selectedOpponent2[0].id;
		 } else if (this.ssOpponent2SearchEl.state.players.length > 0 && this.ssOpponent2SearchEl.state.players[0].id) {
			 opponent2ContactId = this.ssOpponent2SearchEl.state.players[0].id;
		 } else {
			 opponent2ContactId = this.state.selectedOpponent2[0].firstname + ' ' + this.state.selectedOpponent2[0].lastname;
		 }
 
		 if (partnerContactId == opponent1ContactId) {
			 this.showSamePlayererrorMessage('Partner and Opponent 1 players cant be same. Please select appropriate player.');
			 return false;
		 } else if (partnerContactId == opponent2ContactId) {
			 this.showSamePlayererrorMessage('Partner and Opponent 2 players cant be same. Please select appropriate player.');
			 return false;
		 } else if (opponent1ContactId == opponent2ContactId) {
			 this.showSamePlayererrorMessage('Opponent 1 and Opponent 2 players cant be same. Please select appropriate player.');
			 return false;
		 } else if (partnerContactId == opponent1ContactId == opponent2ContactId) {
			 this.showSamePlayererrorMessage('Partner, Opponent 1 and Opponent 2 players cant be same. Please select appropriate players.');
			 return false;
		 }
		 return true;
	 }
 
	 showSamePlayererrorMessage(error) {
		 document.getElementById('same-players-error-section').classList.remove('u-hidden');
		 document.getElementById('same-players-error-section').innerText = error;
		 document.getElementById('same-players-error-section').scrollIntoView();
		 setTimeout(() => {
			 document.getElementById('same-players-error-section').classList.add('u-hidden');
		 }, 5000);
	 }
 
	 validatePreviousPageInputs(currentPosition) {
		 if (currentPosition == 1) {
			 // check for type of sport
			 if (this.state.sportPlayed == null || this.state.sportPlayed == '') {
				 this.showErrorMessage('Which sport did you play? Please edit and update.');
				 return false;
			 }
			 if (this.state.sportPlayed == 'Tennis') {
				 if (this.state.matchFormat == null || this.state.matchFormat == '') {
					 this.showErrorMessage('What form of tennis did you play? Please edit and update.');
					 return false;
				 }
				 if (this.state.tennisBallColor == null || this.state.tennisBallColor == '') {
					 this.showErrorMessage('Select the tennis ball color? Please edit and update.');
					 return false;
				 }
				 if (this.state.matchCategory == null || this.state.matchCategory == '') {
					 this.showErrorMessage('Choose the category of your match? Please edit and update.');
					 return false;
				 }
			 } else if (this.state.sportPlayed == 'Padel') {
				 this.state.matchFormat = 'Doubles';
				 this.state.tennisBallColor = 'Yellow';
				 if (this.state.matchCategory == null || this.state.matchCategory == '') {
					 this.showErrorMessage('Choose the category of your match? Please edit and update.');
					 return false;
				 }
			 }
		 }
		 return true;
	 }
 
	 showErrorMessage(error) {
		 document.getElementById('game-details-error-section').classList.remove('u-hidden');
		 document.getElementById('game-details-error-section').innerText = error;
		 document.getElementById('game-details-error-section').scrollIntoView();
		 setTimeout(() => {
			 document.getElementById('game-details-error-section').classList.add('u-hidden');
		 }, 5000);
	 }
 
	 conditionalNextSection(currentPosition, incrementState) {
		 this._stepSections[0].children.item(currentPosition).classList.add('u-hidden');
		 this._stepSections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
		 this._sections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
		 this._sections[0].children.item(currentPosition + 2).scrollIntoView();
		 if (incrementState) {
			 this.state.section = currentPosition + 1;
		 }
 
	 }
 
	 fillSummaryMatchDetails() {
		 if (this.state.sportPlayed == 'Tennis') {
			 document.querySelector('.sport-type-container').children[1].innerText = this.state.sportPlayed;
			 if (document.querySelector('.match-format-container').classList.contains('u-hidden')) {
				 document.querySelector('.match-format-container').classList.remove('u-hidden');
				 document.querySelector('.match-format-container').children[1].innerText = this.state.matchFormat;
				 document.querySelector('.match-format-container').scrollIntoView();
			 } else {
				 document.querySelector('.match-format-container').children[1].innerText = this.state.matchFormat;
			 }
			 if (document.querySelector('.tennis-ball-color-container').classList.contains('u-hidden')) {
				 document.querySelector('.tennis-ball-color-container').classList.remove('u-hidden');
				 document.querySelector('.tennis-ball-color-container').children[1].innerText = this.state.tennisBallColor;
				 document.querySelector('.tennis-ball-color-container').scrollIntoView();
			 } else {
				 document.querySelector('.tennis-ball-color-container').children[1].innerText = this.state.tennisBallColor;
			 }
			 document.querySelector('.match-catgeory-container').children[1].innerText = this.state.matchCategory;
		 } else if (this.state.sportPlayed == 'Padel') {
			 document.querySelector('.match-format-container').classList.add('u-hidden');
			 document.querySelector('.tennis-ball-color-container').classList.add('u-hidden');
			 document.querySelector('.sport-type-container').children[1].innerText = this.state.sportPlayed;
			 document.querySelector('.match-catgeory-container').children[1].innerText = this.state.matchCategory;
		 }
	 }
 
	 fillSummaryVenueDetails() {
		 // Reset
		 const venueContainer = document.querySelector('.summary-venue-details');
		 venueContainer.innerHTML = '';
 
		 const paragraphBold = document.createElement('p');
		 paragraphBold.classList.add('u-h6');
		 if (this.state.selectedVenue.length > 0) {
			 const venueName = document.createTextNode(this.state.selectedVenue[0].name);
			 const venueStreet = document.createTextNode(this.state.selectedVenue[0].address.street);
			 const venueCity = document.createTextNode(this.state.selectedVenue[0].address.city);
			 const venuePostcode = document.createTextNode(this.state.selectedVenue[0].address.postalcode);
			 paragraphBold.append(venueName);
			 const venueText = document.createElement('h5');
			 venueText.classList.add('u-body3');
			 venueText.append(paragraphBold);
			 venueText.append(venueStreet);
			 venueText.append(document.createElement('br'));
			 venueText.append(venueCity);
			 venueText.append(document.createElement('br'));
			 venueText.append(venuePostcode);
			 venueContainer.append(paragraphBold);
			 venueContainer.append(venueText);
		 }
		 else {
			 const noVenueText = document.createTextNode('No location selected');
			 paragraphBold.append(noVenueText);
			 venueContainer.append(paragraphBold);
		 }
	 }
 
	 fillSummaryPlayerDetails() {
		 // Reset
		 const playerContainer = document.querySelector('.summary-player-details');
		 playerContainer.innerHTML = '';
		 // Generate Tags for Singles opponent
		 if (this.state.matchFormat == 'Singles') {
			 if (this.ssPlayerSearchEl.state.players.length > 0) {
				 this.createTwoLinerTag(this.ssPlayerSearchEl.state.players, null);
			 } else {
				 this.createTwoLinerTag(this.state.selectedPlayer, null);
			 }
		 } else {
			 // Generate Tags for Doubles Partner
			 if (this.ssPartnerSearchEl.state.players.length > 0) {
				 this.createTwoLinerTag(this.ssPartnerSearchEl.state.players, 'Partner');
			 } else {
				 this.createTwoLinerTag(this.state.selectedPartner, 'Partner');
			 }
			 // Generate Tags for Doubles opponent1
			 if (this.ssOpponent1SearchEl.state.players.length > 0) {
				 this.createTwoLinerTag(this.ssOpponent1SearchEl.state.players, 'Opponent 1');
			 } else {
				 this.createTwoLinerTag(this.state.selectedOpponent1, 'Opponent 1');
			 }
			 // Generate Tags for Doubles opponent2
			 if (this.ssOpponent2SearchEl.state.players.length > 0) {
				 this.createTwoLinerTag(this.ssOpponent2SearchEl.state.players, 'Opponent 2');
			 } else {
				 this.createTwoLinerTag(this.state.selectedOpponent2, 'Opponent2');
			 }
 
		 }
	 }
 
	 createTwoLinerTag(playerData, player) {
		 const playerContainer = document.querySelector('.summary-player-details');
		 const playerLabel = document.createElement('label');
		 playerLabel.classList.add('lta-text-input__label');
 
		 const paragraphBold = document.createElement('p');
		 paragraphBold.classList.add('u-h6');
 
		 const playerText = document.createElement('h5');
		 playerText.classList.add('u-body3');
 
		 const paragraphForGender = document.createElement('p');
		 paragraphForGender.classList.add('u-h6');
 
		 if (playerData[0].id) {
			 const firstLine = document.createTextNode(player);
			 const secondLine = document.createTextNode(`${playerData[0].firstname} ${playerData[0].lastname} (${playerData[0].ltanumber})`);
			 const thirdLine = document.createTextNode(`${playerData[0].city} ${playerData[0].county ? ',' + playerData[0].county : ''}`);
			 const fourthLine = document.createTextNode(`${playerData[0].gender}`);
			 playerLabel.append(firstLine);
			 paragraphBold.append(secondLine);
 
 
			 if (playerData[0].city || playerData[0].county) {
				 playerText.append(thirdLine);
			 }
			 if (player != null) playerContainer.append(playerLabel);
			 playerContainer.append(paragraphBold);
			 playerContainer.append(playerText);
			 paragraphForGender.append(fourthLine);
			 playerContainer.append(paragraphForGender);
 
		 } else {
			 const firstLine = document.createTextNode(player);
			 playerLabel.append(firstLine);
			 const secondLine = document.createTextNode(`${playerData[0].firstname} ${playerData[0].lastname}`);
			 if (player != null) playerContainer.append(playerLabel);
			 paragraphBold.append(secondLine);
			 playerContainer.append(paragraphBold);
			 playerContainer.append(document.createElement('br'));
		 }
	 }
 
	 fillSummaryScoreFormats() {
		 document.querySelector('.score-format-container').children[1].innerText = this.state.selectedScoreFormatName;
		 let tb1 = this.state.set1TiebreakScore ? `(${this.state.set1TiebreakScore})` : '';
		 let tb2 = this.state.set2TiebreakScore ? `(${this.state.set2TiebreakScore})` : '';
		 let tb3 = this.state.set3TiebreakScore ? `(${this.state.set3TiebreakScore})` : '';
		 if (this.state.set1Score && this.state.set2Score && this.state.set3Score) {
			 document.querySelector('.match-scores-container').children[1].innerText = this.state.set1Score + tb1 + ', ' + this.state.set2Score + tb2 + ', ' + this.state.set3Score + tb3;
		 } else if (this.state.set1Score && this.state.set2Score && !this.state.set3Score) {
			 document.querySelector('.match-scores-container').children[1].innerText = this.state.set1Score + tb1 + ',  ' + this.state.set2Score + tb2;
		 } else if (this.state.set1Score && !this.state.set2Score) {
			 document.querySelector('.match-scores-container').children[1].innerText = this.state.set1Score + tb1;
		 }
	 }
 
	 fillMatchWinnerDetails() {
		 if (this.state.matchFormat == 'Singles') {
			 document.querySelector('.match-winner-container').children[0].children[0].children[2].classList.add('u-hidden');
			 if (this.state.matchWinner == 'team1') {
				 document.querySelector('.match-winner-container').children[0].children[0].children[1].innerText = this.state.myContactName;
			 } else {
				 document.querySelector('.match-winner-container').children[0].children[0].children[1].innerText = this.state.selectedPlayer[0].firstname + ' ' + this.state.selectedPlayer[0].lastname;
			 }
		 }
		 if (this.state.matchFormat == 'Doubles') {
			 document.querySelector('.match-winner-container').children[0].children[0].children[2].classList.remove('u-hidden');
			 if (this.state.matchWinner == 'team1') {
				 document.querySelector('.match-winner-container').children[0].children[0].children[1].innerText = this.state.myContactName;
				 if (this.ssPartnerSearchEl.state.players.length > 0) {
					 document.querySelector('.match-winner-container').children[0].children[0].children[2].innerText = this.ssPartnerSearchEl.state.players[0].firstname + ' ' + this.ssPartnerSearchEl.state.players[0].lastname;
				 } else {
					 document.querySelector('.match-winner-container').children[0].children[0].children[2].innerText = this.state.selectedPartner[0].firstname + ' ' + this.state.selectedPartner[0].lastname;
				 }
			 } else {
				 if (this.ssOpponent1SearchEl.state.players.length > 0) {
					 document.querySelector('.match-winner-container').children[0].children[0].children[1].innerText = this.ssOpponent1SearchEl.state.players[0].firstname + ' ' + this.ssOpponent1SearchEl.state.players[0].lastname;
				 } else {
					 document.querySelector('.match-winner-container').children[0].children[0].children[1].innerText = this.state.selectedOpponent1[0].firstname + ' ' + this.state.selectedOpponent1[0].lastname;
				 }
				 if (this.ssOpponent2SearchEl.state.players.length > 0) {
					 document.querySelector('.match-winner-container').children[0].children[0].children[2].innerText = this.ssOpponent2SearchEl.state.players[0].firstname + ' ' + this.ssOpponent2SearchEl.state.players[0].lastname;
				 } else {
					 document.querySelector('.match-winner-container').children[0].children[0].children[2].innerText = this.state.selectedOpponent2[0].firstname + ' ' + this.state.selectedOpponent2[0].lastname;
				 }
			 }
		 }
	 }
 
	 goToPreviousSection() {
		 let allSections = document.querySelectorAll('.content-container .section');
		 let allSteps = document.querySelectorAll('.steps-container .self-submission-steps');
		 allSections.forEach((el, i) => {
			 if (el.classList.contains('u-hidden')) {
				 console.log(i);
			 } else {
				 if (i == 0) {
					 this._exitModal.show();
					 return;
				 } else {
					 // For Singles
					 if (this.state.matchFormat == 'Singles') {
						 this.state.section = i - 1;
						 this.state.currentEventSection = i - 1;
						 // To hide Current section and go back to previous section considering [1 and above]
						 allSections[i].classList.add('u-hidden');
						 allSections[i - 1].classList.remove('u-hidden');
						 this.displayPlayerSection(null, this.state.playerDataAttributes.singlesOpponent)
					 } else {
						 // For Doubles
						 if (i == 4) {
							 // from summary to score format
							 this.state.section = 3;
							 this.state.currentEventSection = 3;
							 allSections[i].classList.add('u-hidden');
							 allSections[i - 1].classList.remove('u-hidden');
						 } else if (i == 3) {
							 // score format to opponent2
							 this.state.section = 2;
							 this.state.currentEventSection = 2;
							 allSections[i].classList.add('u-hidden');
							 allSections[i - 1].classList.remove('u-hidden');
							 this.state.stepPartner = false;
							 this.state.stepOpponent1 = false;
							 this.state.stepOpponent2 = false;
							 this.displayPlayerSection(null, this.state.playerDataAttributes.doublesOpponent2);
						 } else if (i == 2) {
							 // from opponent 2 to opponent 1
							 if (!document.querySelector('.player-search-doubles-opponents2').classList.contains('u-hidden')) {
								 this.state.section = 1;
								 this.state.currentEventSection = 2;
								 this.state.stepPartner = false;
								 this.state.stepOpponent1 = false;
								 this.state.stepOpponent2 = true;
								 document.querySelector('.player-search-doubles-opponents2').classList.add('u-hidden');
								 document.querySelector('.player-search-doubles-opponents1').classList.remove('u-hidden');
								 this.displayPlayerSection(null, this.state.playerDataAttributes.doublesOpponent1);
							 } else if (!document.querySelector('.player-search-doubles-opponents1').classList.contains('u-hidden')) {
								 // from opponent 1 to partner
								 this.state.section = 1;
								 this.state.currentEventSection = 2;
								 this.state.stepPartner = false;
								 this.state.stepOpponent1 = true;
								 this.state.stepOpponent2 = false;
								 document.querySelector('.player-search-doubles-opponents2').classList.add('u-hidden');
								 document.querySelector('.player-search-doubles-opponents1').classList.add('u-hidden');
								 document.querySelector('.player-search-doubles-partner').classList.remove('u-hidden');
								 this.displayPlayerSection(null, this.state.playerDataAttributes.doublesPartner);
							 } else if (!document.querySelector('.player-search-doubles-partner').classList.contains('u-hidden')) {
								 // from partner to game details
								 this.state.stepPartner = false;
								 this.state.stepOpponent1 = false;
								 this.state.stepOpponent2 = false;
								 allSections[i].classList.add('u-hidden');
								 allSections[i - 1].classList.remove('u-hidden');
								 this.state.section = 1;
								 this.state.currentEventSection = 1;
							 }
						 } else if (i == 1) {
							 // from partner to game details
							 this.state.section = 0;
							 this.state.currentEventSection = 0;
							 allSections[i].classList.add('u-hidden');
							 allSections[i - 1].classList.remove('u-hidden');
						 } else {
							 // from game details to venue and calendar
							 this.state.section = 0;
							 this.state.currentEventSection = 0;
						 }
					 }
					 // Handling the step view
					 if (i == 4) {
						 this._stepSections[0].classList.remove('u-hidden');
						 // allSteps[i].classList.add('u-hidden');
						 allSteps[i - 1].classList.remove('u-hidden');
					 } else if (i == 3 || i == 1 || i == 0) {
						 allSteps[i].classList.add('u-hidden');
						 allSteps[i - 1].classList.remove('u-hidden');
					 } else if (i == 2) {
						 if (this.state.currentEventSection == 1) {
							 allSteps[i].classList.add('u-hidden');
							 allSteps[i - 1].classList.remove('u-hidden');
						 }
					 }
				 }
				 return;
			 }
		 });
	 }
 
	 goToPreviousPart() {
		 const currentSection = this._sections[0].children.item(this.state.section + 1);
		 const sectionParts = currentSection.querySelectorAll('.js-lta-section-content');
		 let currentPart;
		 sectionParts.forEach((part) => {
			 if (!part.classList.contains('u-hidden')) {
				 currentPart = part;
			 }
		 });
		 currentPart.classList.add('u-hidden');
		 currentPart.previousElementSibling.classList.remove('u-hidden');
		 this._modal.scrollTop = 1;
	 }

	

 }
 
 const selfSubmission = new SelfSubmission();
 
 export default selfSubmission;
 
 